import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import moment from 'moment-timezone';
import { withRouter } from 'react-router';
import localStorage from 'local-storage';
import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';
import includes from 'lodash/includes';
import queryString from 'query-string';
import { firebaseAnalyticsNO, _auth } from '../../firebase';
import Layout from '../../containers/Layout';
import { validateVoucher } from '../../components/OrderReview/voucherHelper';
import MenuItems from '../../components/MenuItems';
import Order from '../../containers/Order';
import { loadCurrentOrderMethod } from './methods';
import getFormattedMobileNumber from '../../helpers/getFormattedMobileNumber';
import { getDineInObjects } from '../../helpers/getDineInObjects';
import {
  getDayFlag,
  getCurrentDayFlag,
  getCurrentTimestamp,
  getTimestampForMomentDate,
} from '../../helpers/timeHelper';
import {
  getCurrentUseDetails,
  toggleMobileCart,
  setLayoutFlow,
  setState,
  updateCurrentOrderObj,
  filterView,
  addReservation,
  takeSignOutAction,
  init,
} from './actions';
import { eventNames } from 'configuration/eventNames';
import SafariAddressBarDetector from 'detect-ios-address-bar';
import ConfirmTable from 'components/ConfirmTable';
import SelectTable from 'components/SelectTable';
import ReviewOrder from 'containers/ReviewOrder';
import { isObjectNotEmpty } from 'utils';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowItems: [],
      selectedHalfItems: [],
      toggleAnimation: false,
      toggleSpecials: false,
      toggleSpeacialItem: false,
      halfItem: {},
      specialItem: {},
      arrKey: '',
      halfAnimation: false,
      rightSideViewVisibilityIndex: 0,
      itemVariants: [],
      whichHalf: 0,
      itemExist: -1,
      inLayoutFlow: false,
      loyalty: false,
      dineInObjects: [],
      floors: {},
      showSelectTable: false,
      showConfirmTable: true,
    };
    this.specialItemsObj = [];
    this.itemsUsed = [];
    this.query = new URLSearchParams(window.location.search);
    this.qrRedirect = this.query.get('qrRedirect');
    this.qrTracking = this.query.get('qrTracking');
  }

  componentWillMount() {
    const {
      setState,
      currentOrder,
      storeConfig,
      initAction,
      getCurrentUseDetailsHandler,
    } = this.props;

    initAction(storeConfig.storeId, storeConfig.restaurantId);

    _auth.onAuthStateChanged((user) => {
      if (user) {
        getCurrentUseDetailsHandler(
          user,
          null,
          storeConfig.storeId,
          storeConfig.restaurantId
        );
      }
    });
    const loadedOrder = loadCurrentOrderMethod(storeConfig, currentOrder);
    if (loadedOrder.type === '1') {
      loadedOrder.address = '';
      loadedOrder.addressLocation = '';
      loadedOrder.placeId = '';
      loadedOrder.suburbId = '';
      loadedOrder.minOrderValue = '';
      loadedOrder.areaCode = '';
      loadedOrder.area = '';
      loadedOrder.deliveryCost = 0;
      loadedOrder.deliveryDate = undefined;
      loadedOrder.deliveryData = {};
    } else {
      loadedOrder.deliveryDate = undefined;
    }
    let newOrder = this.getOrderCalculations(loadedOrder);
    setState({ currentOrder: newOrder });

    if (this.qrRedirect === 'true' || this.qrTracking === 'close') {
      this.goHome();
    }
  }

  componentDidMount() {
    firebaseAnalyticsNO.logEvent(eventNames.HOME_PAGE_VISITED);
    this.handleRedirectionFromMultistore();

    // Initialize instance
    const safariAddressBar = new SafariAddressBarDetector();
    if (safariAddressBar) {
      if (safariAddressBar.isTargetDevice) {
        document.body.style.marginBottom = `40px`;
      }
    }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  confirmTable = (number) => {
    const selectedTables = this.state?.dineInObjects?.filter(
      (item) => item.name === number || item.number === number
    );

    if (selectedTables.length !== 1) {
      this.setState({ showSelectTable: true });
    } else {
      this.addTableToOrder(selectedTables[0]);
    }
  };

  checkForDineIn = async () => {
    const { home, setState, currentOrder, storeConfig, history } = this.props;
    const { storeId } = storeConfig;
    const pathname = window.location.pathname;
    const isDineIn = pathname.includes('dine-in');
    const type = 'dine-in';
    let dineInObject = null;

    if ((isDineIn || currentOrder?.orderType === '3') && home.orderSetup) {
      const isDineInDisabled = !home.orderSetup.isDineInOn;

      if (isDineInDisabled) {
        history.push('/');
        return;
      }
      const { tables: dineInObjects, floors } = await getDineInObjects(storeId);
      this.setState({ type, dineInObjects, floors });

      // pre-select the table if it's in the url
      const urlPaths = pathname.split('/').filter(Boolean);
      const isTableNumber = isDineIn && urlPaths.length === 3;
      const floorLayoutId = isTableNumber
        ? urlPaths[urlPaths.length - 2]
        : false;
      const number = isTableNumber
        ? urlPaths[urlPaths.length - 1]?.replace('table-', '')
        : false;

      if (dineInObjects?.length > 0) {
        if (number) {
          dineInObject = dineInObjects.find(
            (item) =>
              (item.name === number || item.number === number) &&
              (item.floorLayoutId === floorLayoutId ||
                floors[item.floorLayoutId].name.toLowerCase() ===
                  floorLayoutId.toLowerCase())
          );
          if (dineInObject) {
            this.addTableToOrder(dineInObject);
          } else {
            setState({
              currentOrder: { ...currentOrder, orderType: `3` },
            });
          }
        } else {
          setState({
            currentOrder: { ...currentOrder, orderType: `3` },
          });
        }
      }
    }
  };

  handleRedirectionFromMultistore = () => {
    const { setState, currentOrder } = this.props;
    const query = queryString.parse(window.location.search);
    if (query?.lat) {
      query.lat = Number(query.lat);
    }
    if (query?.lng) {
      query.lng = Number(query?.lng);
    }

    let {
      type,
      address,
      lat,
      lng,
      placeId,
      suburbId,
      deliveryCost,
      minOrderValue,
      areaCode,
      area,
    } = query;

    if (type) this.setState({ type });
    if (
      address &&
      lat &&
      lng &&
      placeId &&
      suburbId &&
      deliveryCost &&
      minOrderValue
    ) {
      this.setState({
        address,
        lat,
        lng,
        placeId,
        suburbId,
        deliveryCost,
        minOrderValue,
        ...(areaCode && area
          ? {
              areaCode,
              area,
            }
          : {}),
      });
      setState({
        currentOrder: {
          ...currentOrder,
          areaCode,
          area,
        },
      });
      this.openAppSectionForType(query);
    }
  };

  getOrderCalculations = (orderObj) => {
    const {
      storeConfig,
      home,
      order,
      autoVouchers,
      publicHolidays,
      currentOrder,
    } = this.props;

    const { orderSetup } = home;

    let currentOd = JSON.parse(
      JSON.stringify({ ...currentOrder, ...orderObj })
    );

    const { menuItems } = currentOd;

    let deliveryCost = 0;
    let voucherDiscount = 0;
    let loyaltyDiscount = 0;
    let upsalePrice = 0;
    let specialDiscount = 0;
    let creditCardCharges = 0;
    let platformSurchargeAmt = 0;
    let isPlatformSurchargeLevied = false;
    let tax = 0;
    let totalCost = menuItems.reduce(
      (acc, m) => (acc += parseFloat(this.getItemPrice(m))),
      0
    );
    let payableAmount = Number(totalCost.toFixed(2));

    menuItems.forEach((m, i) => {
      m.orderIndex = i;
    });

    if (!currentOd?.voucherId && autoVouchers?.length > 0) {
      const otMap = { 1: 'Pickup', 2: 'Delivery', 3: 'DineIn' };
      const { orderType } = currentOd;
      const suffix = otMap[orderType];
      let matchingVouchers = autoVouchers.filter(
        (f) => f[`isAvailable${suffix}`]
      );
      if (matchingVouchers.length > 0) {
        let selectedVoucher = matchingVouchers[0];
        currentOd.voucherId = selectedVoucher._id;
        currentOd.selectedVoucher = selectedVoucher;
      }
    }

    const itemsInCart = this.getItemsInCart(currentOd);

    let rowItems = sortBy(itemsInCart, 'price').reverse();

    // Loyalty discount
    let offers = this.detectOffers(currentOd, rowItems);
    let rewards = offers.flatMap((p) => p.rewards);
    let discount = rewards.reduce(
      (total, obj) => (total += Number(obj.discount)),
      0
    );

    if (discount > 0) {
      payableAmount = Number((payableAmount - Number(discount)).toFixed(2));
      loyaltyDiscount = parseFloat(discount).toFixed(2);
      rowItems = rowItems.map((p) => {
        if (this.itemsUsedForReward.includes(p.primaryKey))
          p.isUsedForReward = true;
        else p.isUsedForReward = false;
        return p;
      });
    } else {
      rewards = [];
    }

    rowItems = rowItems.filter((f) => {
      return !(f.isSecondHalf || f.isUsedForReward);
    });

    // Calculate speical's discount
    let specialObj = this.detectSpecial(currentOd, rowItems);
    rowItems = specialObj.rowItems;
    this.setState({ rowItems });

    let specials = specialObj.specials;
    if (specials) {
      let discount = 0;
      specials.map((s) => {
        discount = discount + Math.abs(Number(s.discount));
        upsalePrice = upsalePrice + Number(s.upsalePrice);
        return s;
      });
      if (discount > 0) {
        payableAmount = Number(
          (payableAmount - (Number(discount) - Number(upsalePrice))).toFixed(2)
        );
        specialDiscount = parseFloat(
          Number(discount) - Number(upsalePrice)
        ).toFixed(2);
      } else {
        specials = [];
      }
    }

    currentOd.specials = specials;

    // Calculate voucher's discount
    let matchingVouchers = [];
    if (currentOd.voucherId && currentOd.menuItems.length > 0) {
      let myVouchers = currentOd.selectedVoucher
        ? [currentOd.selectedVoucher]
        : [];
      const otMap = { 1: 'Pickup', 2: 'Delivery', 3: 'DineIn' };
      const { orderType } = currentOd;
      const suffix = otMap[orderType];
      myVouchers = myVouchers.filter((f) => f[`isAvailable${suffix}`]);
      matchingVouchers = myVouchers.filter(
        (v) => v._id === currentOd.voucherId
      );
      if (matchingVouchers.length > 0) {
        let selectedVoucher = matchingVouchers[0];
        if (
          validateVoucher(
            storeConfig,
            selectedVoucher,
            currentOd,
            payableAmount,
            this.props.home.userDetails
          ).success
        ) {
          let voucherDiscountObj = this.getDiscountedAmount(
            selectedVoucher,
            currentOd,
            rowItems,
            specialDiscount,
            payableAmount
          );
          if (voucherDiscountObj.isVoucherValid) {
            if (
              selectedVoucher.type === '3' &&
              !selectedVoucher.isAvailableWithSpecials
            ) {
              voucherDiscount = Number(voucherDiscountObj.discount).toFixed(2);
              if (voucherDiscountObj.isItemOccupiedWithSpecials) {
                //Find matching special
                specials = voucherDiscountObj.specials;
                if (specials) {
                  let discount = 0;
                  payableAmount = Number(totalCost.toFixed(2));
                  specials.map((s) => {
                    discount = discount + Number(s.discount);
                    return s;
                  });
                  if (discount > 0) {
                    payableAmount = Number(
                      (payableAmount - Number(discount)).toFixed(2)
                    );
                    specialDiscount = parseFloat(discount).toFixed(2);
                  } else {
                    specials = [];
                  }
                }
              }
              if (payableAmount >= Number(voucherDiscount)) {
                payableAmount = payableAmount - voucherDiscount;
              } else {
                voucherDiscount = payableAmount.toFixed(2);
                payableAmount = 0;
              }
            } else {
              voucherDiscount = Number(voucherDiscountObj.discount).toFixed(2);
              if (payableAmount >= Number(voucherDiscount)) {
                payableAmount = payableAmount - voucherDiscount;
              } else {
                voucherDiscount = payableAmount.toFixed(2);
                payableAmount = 0;
              }
            }
          } else {
            currentOd.voucherDiscount = '0';
            currentOd.voucherId = '';
            currentOd.voucherName = '';
            currentOd.selectedVoucher = {};
          }
        } else {
          // Reset voucher details if there is mo matching voucher in master list
          currentOd.voucherDiscount = '0';
          currentOd.voucherId = '';
          currentOd.voucherName = '';
          currentOd.selectedVoucher = {};
        }
      } else {
        // Reset voucher details if there is mo matching voucher in master list
        currentOd.voucherDiscount = '0';
        currentOd.voucherId = '';
        currentOd.voucherName = '';
        currentOd.selectedVoucher = {};
      }
    } else {
      currentOd.voucherId = '';
      currentOd.voucherDiscount = '0';
      currentOd.voucherName = '';
      currentOd.selectedVoucher = {};
    }

    // Calculate delivery fee
    if (currentOd.orderType === '2' && currentOd.menuItems.length > 0) {
      if (
        this.props?.home?.orderSetup?.isDeliveryFreeOver &&
        Number(this.props?.home?.orderSetup?.deliveryFreeOver) < payableAmount
      ) {
        deliveryCost = 0;
      } else if (
        this.props.home?.orderSetup?.useRadiusBasedDeliveryAreaCalulation
      ) {
        deliveryCost = currentOd?.deliveryData?.deliveryCost || '0';
        payableAmount = payableAmount + Number(deliveryCost);
      } else {
        if (this.props.order.allSuburbs && currentOd.suburbId) {
          let subs = this.props.order.allSuburbs.filter((s) => {
            return s._id === currentOd.suburbId;
          });
          if (subs.length > 0) {
            if (
              orderSetup?.isFirstDeliveryFree &&
              this.props.home.userDetails &&
              (!this.props.home.userDetails.totalDeliveryOrders ||
                (this.props.home.userDetails.totalDeliveryOrders &&
                  Number(this.props.home.userDetails.totalDeliveryOrders) <= 0))
            ) {
              deliveryCost = 0;
            } else {
              payableAmount = payableAmount + Number(subs[0].deliveryCost);
              deliveryCost = subs[0]?.deliveryCost || 0;
            }
          } else {
            deliveryCost = 0;
          }
        } else {
          deliveryCost = 0;
        }
      }
    }

    if (
      currentOd.deliveryDate &&
      orderSetup?.isOptedInForHolidaySurcharge &&
      orderSetup?.publicHolidaySurcharge &&
      publicHolidays?.length > 0
    ) {
      let dates = publicHolidays.filter((m) => {
        return (
          m ===
          moment(currentOd.deliveryDate, 'YYYY-MM-DD HH:mm').format(
            'YYYY-MM-DD'
          )
        );
      });
      if (dates.length > 0) {
        let publicHolidaySurcharge = 0;
        publicHolidaySurcharge =
          (payableAmount * Number(orderSetup.publicHolidaySurcharge)) / 100;
        payableAmount = payableAmount + publicHolidaySurcharge;
        currentOd.publicHolidaySurcharge = parseFloat(
          publicHolidaySurcharge
        ).toFixed(2);
        currentOd.publicHolidaySurchargePer = orderSetup.publicHolidaySurcharge;
      } else {
        currentOd.publicHolidaySurcharge = '0';
        currentOd.publicHolidaySurchargePer = '0';
      }
    } else {
      currentOd.publicHolidaySurcharge = '0';
      currentOd.publicHolidaySurchargePer = '0';
    }

    // GST
    if (orderSetup?.isDisplayGST && orderSetup?.isPriceIncludesGST) {
      tax = payableAmount / 11;
      currentOd.isDisplayGST = true;
      currentOd.isPriceIncludesGST = true;
    } else if (orderSetup?.isDisplayGST && !orderSetup?.isPriceIncludesGST) {
      tax = (payableAmount * 10) / 100;
      payableAmount = payableAmount + tax;
      currentOd.isDisplayGST = true;
      currentOd.isPriceIncludesGST = false;
    } else {
      currentOd.isDisplayGST = false;
    }

    // Credit card processing
    if (currentOd.paymentType === '2') {
      if (orderSetup.isCustomerLiableForOnlineCharges) {
        const percentageCharge = 1.75;
        const fixedCharge = 0.3;
        creditCardCharges =
          parseFloat(payableAmount) * (percentageCharge / 100) + fixedCharge;
      }

      // Platform charges processing
      if (
        orderSetup.isPlatformSurchargeLevied &&
        orderSetup.platformSurchargeAmt &&
        currentOd.orderType !== '3'
      ) {
        isPlatformSurchargeLevied = true;
        platformSurchargeAmt = orderSetup.platformSurchargeAmt;
      }
    }

    // Order's payable amount
    payableAmount = parseFloat(payableAmount).toFixed(2);
    totalCost = parseFloat(totalCost).toFixed(2);

    currentOd.totalCost = totalCost;
    currentOd.payableAmount = payableAmount;
    currentOd.creditCardCharges = Number(creditCardCharges).toFixed(2);
    currentOd.platformSurchargeAmt = Number(platformSurchargeAmt).toFixed(2);
    currentOd.isPlatformSurchargeLevied = isPlatformSurchargeLevied;
    currentOd.gst = Number(tax).toFixed(2);
    currentOd.deliveryCost = deliveryCost?.toString() || '0';
    currentOd.specialDiscount = specialDiscount.toString();
    currentOd.upsalePrice = parseFloat(upsalePrice).toFixed(2);
    currentOd.loyaltyDiscount = loyaltyDiscount.toString();
    currentOd.specials = specials;
    currentOd.rewards = rewards;
    currentOd.offers = offers;
    currentOd.isFreeItemsAvailable =
      offers.length > rewards.length ? true : false;

    // Reset voucher if discount is zero
    if (voucherDiscount <= 0) {
      currentOd.voucherDiscount = '0';
      currentOd.voucherId = '';
      currentOd.voucherName = '';
      currentOd.selectedVoucher = {};
    } else {
      currentOd.voucherDiscount = voucherDiscount.toString();
      currentOd.voucherName =
        matchingVouchers && matchingVouchers.length > 0
          ? matchingVouchers[0].voucherCode
          : '';
    }

    // Check order is good to move to review screen or not
    if (currentOd.menuItems && currentOd.menuItems.length > 0) {
      const totalCostForDelivery = (
        Number(currentOd.payableAmount) -
        Number(currentOd.deliveryCost ? currentOd.deliveryCost : 0)
      ).toFixed(2);

      const suburb = order?.allSuburbs?.find((s) => {
        return s._id === currentOd.suburbId;
      });

      const minDeliveryValue = orderSetup?.useRadiusBasedDeliveryAreaCalulation
        ? Number(currentOd.minOrderValue)
        : Number(suburb?.minOrderValue) ||
          Number(orderSetup?.minDeliveryOrderValue);

      if (
        currentOd.orderType === '1' &&
        orderSetup &&
        Number(currentOd.payableAmount) >=
          Number(
            orderSetup.minPickupOrderValue ? orderSetup.minPickupOrderValue : 0
          )
      ) {
        currentOd.isAllowToConfirm = true;
      } else if (
        currentOd.orderType === '2' &&
        orderSetup &&
        totalCostForDelivery >= minDeliveryValue &&
        currentOd.address !== ''
      ) {
        currentOd.isAllowToConfirm = true;
      } else if (currentOd.orderType === '3' && currentOd.tableId) {
        currentOd.isAllowToConfirm = true;
      } else currentOd.isAllowToConfirm = false;
    } else currentOd.isAllowToConfirm = false;

    // this.props.updateCurrentOrderObjHandler(currentOd.id, currentOd);
    return currentOd;
  };

  openAppSectionForType = ({
    type,
    address,
    lat,
    lng,
    placeId,
    suburbId,
    deliveryCost,
    minOrderValue,
    areaCode,
  }) => {
    const { storeConfig, setState, currentOrder } = this.props;

    switch (type) {
      case 'dine-in':
      case 'pickup':
        let loadedOrder = loadCurrentOrderMethod(storeConfig, currentOrder);
        loadedOrder.orderType = type === 'dine-in' ? '3' : '1';
        let currentOd = this.getOrderCalculations(loadedOrder);
        setState({ currentOrder: currentOd });
        this.setState({ type: `` });
        break;
      case 'delivery': {
        let loadedOrder = loadCurrentOrderMethod(storeConfig, currentOrder);
        loadedOrder.orderType = '2';
        loadedOrder.address = address || '';
        loadedOrder.addressLocation = lat && lng ? { lat, lng } : {};
        loadedOrder.placeId = placeId || '';
        loadedOrder.suburbId = suburbId || '';
        loadedOrder.deliveryCost = deliveryCost || '0';
        loadedOrder.minOrderValue = minOrderValue || '0';
        loadedOrder.areaCode = areaCode || '';
        let currentOd = this.getOrderCalculations(loadedOrder);
        setState({ currentOrder: currentOd, type: '' });
        break;
      }
      default:
        break;
    }
  };

  componentWillReceiveProps(props) {
    const { orderSetup, currentOrder, menuItems, allSpecials, halfHalf } =
      props.home;
    const { setState } = this.props;

    if (currentOrder && currentOrder._id && currentOrder.orderStatus !== '-1') {
      this.redirectAndCleanupOrder(props);
    }

    if (currentOrder && menuItems && allSpecials && halfHalf && orderSetup) {
      this.urlChange(props.location.pathname, true);
    }

    if (
      orderSetup &&
      Object.keys(orderSetup).length &&
      !this.state.orderSetup
    ) {
      this.setState({ orderSetup }, () => {
        this.checkForDineIn();
      });
    }

    if (
      orderSetup &&
      !orderSetup.isDeliveryOn &&
      orderSetup.isPickupOn &&
      currentOrder.orderType !== '1' &&
      currentOrder.orderType !== '3'
    ) {
      let loadedOrder = loadCurrentOrderMethod(props.storeConfig, currentOrder);
      loadedOrder.orderType = '1';
      setState({ currentOrder: loadedOrder });
    } else if (
      orderSetup &&
      !orderSetup.isPickupOn &&
      orderSetup.isDeliveryOn &&
      currentOrder.orderType !== '2' &&
      currentOrder.orderType !== '3'
    ) {
      let loadedOrder = loadCurrentOrderMethod(props.storeConfig, currentOrder);
      loadedOrder.orderType = '2';
      setState({ currentOrder: loadedOrder });
    }
    if (
      currentOrder?.orderType === '3' &&
      !currentOrder?.tableNumber &&
      currentOrder?.stage < 4 &&
      props.mobileCart
    ) {
      this.setState({ showConfirmTable: true });
    }
  }

  redirectAndCleanupOrder = ({
    home: {
      currentOrder: { _id, orderType },
    },
  }) => {
    if (window.localStorage) {
      const cachedOrder = localStorage.get('currentOrder');
      if (cachedOrder) {
        localStorage.set('currentOrder', {
          address: '',
          addressLocation: {},
          orderStatus: '0',
          orderFrom: '1',
          orderType: '1',
          specials: [],
          menuItems: [],
          stage: 0,
          totalCost: 0,
          payableAmount: 0,
          isAllowToConfirm: false,
        });
      }
    }
    firebaseAnalyticsNO.logEvent(eventNames.PAID_FOR_ORDER);
    if (this.qrRedirect !== 'true' && this.qrTracking !== 'close') {
      this.props.history.replace(`/order-tracking/${_id}/${orderType}`);
    }
  };

  addReservationhandler = (obj) => {
    const {
      home: { userDetails },
    } = this.props;
    if (userDetails && userDetails._id) {
      if (isNaN(obj.reservationDate) === true) {
        let reservationInterimDate = new Date(obj.reservationDate);
        obj.reservationDateTimestamp = reservationInterimDate.getTime();
      }
      this.props.addReservationhandler(obj, userDetails);
    }
  };

  // ~updaters~

  updateCurrentUser = (user, details, stage) => {
    const { storeConfig, setState, currentOrder, bookingOpen } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    let newUser = {
      date: moment().tz(storeConfig.timeZone).format(),
      dateTimestamp: getCurrentTimestamp(),
      deviceToken: '',
      email: details.userEmail ? details.userEmail : '',
      firstName: details.firstName,
      isActive: true,
      lastName: details.lastName,
      mobileNumber: getFormattedMobileNumber(details.mobileNumber),
      password: '',
      streetAddress: currentOrder.address ? currentOrder.address : '',
      addressLocation: currentOrder.addressLocation
        ? currentOrder.addressLocation
        : '',
      suburbId: currentOrder.suburbId ? currentOrder.suburbId : '',
      type: '3',
      userRole: '3',
      userId: user.uid,
      ratings: 0,
      totalRatings: 0,
      averageRating: 0,
      totalOrders: 0,
      totalRevenue: 0,
      totalDeliveryOrders: 0,
      totalDeliveryOrdersNow: 0,
      totalPickupOrders: 0,
      deliveryRevenue: 0,
      pickupRevenue: 0,
      totalDeliveryTime: 0,
      averageDeliveryTime: 0,
      storeId: storeConfig.storeId,
      restaurantId: storeConfig.restaurantId,
    };

    if (stage === 3 && (this.state.reservation || bookingOpen)) {
      currentOd.stage = 0;
    } else {
      if (this.state.reservation) {
        currentOd.stage = 0;
      } else if (this.state.initiateDesktopLoyaltyFlow || this.state.loyalty) {
        currentOd.stage = 0;
      } else {
        currentOd.stage = stage;
      }
    }
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
    this.setState({ userDetails: newUser }, () => {
      this.props.getCurrentUseDetailsHandler(
        user,
        newUser,
        storeConfig.storeId,
        storeConfig.restaurantId,
        true
      );
    });
  };

  updateOrderType = (type, flag) => {
    const { setState, currentOrder } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    if (type === '1') {
      currentOd.orderType = type;
      currentOd.address = '';
      currentOd.addressLocation = '';
      currentOd.placeId = '';
      currentOd.suburbId = '';
      currentOd.minOrderValue = '';
      currentOd.areaCode = '';
      currentOd.area = '';
      currentOd.deliveryCost = 0;
      currentOd.deliveryDate = undefined;
      currentOd.deliveryData = {};
    } else {
      currentOd.orderType = type;
      currentOd.deliveryDate = undefined;
    }
    let newOrder = this.getOrderCalculations(currentOd);
    setState({
      currentOrder: {
        ...newOrder,
        notes: currentOd.notes,
      },
    });
    this.setState({
      type: flag ? this.state.type : undefined,
      address: flag ? this.state.address : undefined,
      lat: flag ? this.state.lat : undefined,
      lng: flag ? this.state.lng : undefined,
      placeId: flag ? this.state.placeId : undefined,
      suburbId: flag ? this.state.suburbId : undefined,
      deliveryCost: flag ? this.state.deliveryCost : undefined,
      minOrderValue: flag ? this.state.minOrderValue : undefined,
      areaCode: flag ? this.state.areaCode : undefined,
    });
  };

  updateOrderStage = (stage) => {
    const { currentOrder, setState, home } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    if (
      stage === 1 &&
      (home?.currentUser?.phoneNumber || home?.userDetails?.mobileNumber)
    ) {
      setState({ currentOrder: { ...currentOrder, stage: 3 } });
    } else if (stage === 3) {
      if (currentOd.stage === 4.1) {
        setState({ currentOrder: { ...currentOrder, stage: 4 } });
      }
    } else {
      currentOd.stage = stage;
      if (stage === 4) {
        currentOd.paymentType = '0';
      }
      if (stage === 4.1) currentOd.paymentType = '2';
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: newOrder });
    }
  };

  updateOrderStageBack = () => {
    const { currentOrder, setState } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    if (currentOrder.stage === 3) {
      setState({ currentOrder: { ...currentOrder, stage: 0 } });
    } else if (currentOrder.stage === 2) {
      setState({ currentOrder: { ...currentOrder, stage: 1.1 } });
    } else if (currentOrder.stage === 1.1) {
      setState({ currentOrder: { ...currentOrder, stage: 1 } });
    } else if (currentOrder.stage === 4.1) {
      setState({
        currentOrder: { ...currentOrder, stage: 4, paymentType: `0` },
      });
    } else {
      if (currentOrder.stage === 1 || currentOrder.stage === 4)
        currentOd.stage = currentOd.stage - 1;
      if (
        (this.state.initiateDesktopLoyaltyFlow || this.state.loyalty) &&
        currentOrder.stage === 1
      ) {
        this.props.setLayoutFlow(false);
      }
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: newOrder });
    }
  };

  updateOrderDeliveryAddress = (addressObj, suburb, areaCode, area) => {
    const { currentOrder, setState } = this.props;
    if (
      addressObj &&
      addressObj.label &&
      addressObj.location &&
      addressObj.placeId
    ) {
      let currentOd = JSON.parse(JSON.stringify(currentOrder));
      currentOd.address = addressObj.label.trim();
      currentOd.addressLocation = addressObj.location;
      currentOd.placeId = addressObj.placeId;
      currentOd.suburbId = suburb._id;
      currentOd.deliveryCost = suburb.deliveryCost.toString();
      currentOd.minOrderValue = suburb.minOrderValue
        ? suburb.minOrderValue
        : '0';
      currentOd.areaCode = areaCode;
      currentOd.area = area;
      currentOd.deliveryData = suburb;
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: { ...newOrder } });
    } else {
      let currentOd = JSON.parse(JSON.stringify(currentOrder));
      currentOd.address = '';
      currentOd.addressLocation = '';
      currentOd.suburbId = '';
      currentOd.deliveryCost = '';
      currentOd.minOrderValue = '0';
      currentOd.areaCode = '';
      currentOd.area = '';
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: { ...newOrder } });
    }
  };

  updateDeliveryPickupTime = (
    deliveryDate,
    shiftId,
    isCartConfirm,
    stage,
    isFutureDeliveryDate
  ) => {
    const { setState, storeConfig, home, currentOrder } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    if (isCartConfirm) {
      if (
        stage === 1 &&
        (home?.currentUser?.phoneNumber || home?.userDetails?.mobileNumber)
      ) {
        currentOd.deliveryDate = deliveryDate.format('YYYY-MM-DD HH:mm');
        currentOd.deliveryDateTimestamp = getTimestampForMomentDate(
          deliveryDate,
          storeConfig.timeZone,
          'YYYY-MM-DD HH:mm'
        );
        currentOd.shiftId = shiftId;
        currentOd.stage = 3;
        currentOd.isFutureDeliveryDate = isFutureDeliveryDate;
        let newOrder = this.getOrderCalculations(currentOd);
        setState({ currentOrder: newOrder });
      } else {
        currentOd.deliveryDate = deliveryDate.format('YYYY-MM-DD HH:mm');
        currentOd.deliveryDateTimestamp = getTimestampForMomentDate(
          deliveryDate,
          storeConfig.timeZone,
          'YYYY-MM-DD HH:mm'
        );
        currentOd.shiftId = shiftId;
        currentOd.stage = stage;
        currentOd.isFutureDeliveryDate = isFutureDeliveryDate;
        let newOrder = this.getOrderCalculations(currentOd);
        setState({ currentOrder: newOrder });
      }
    } else {
      currentOd.deliveryDate = deliveryDate.format('YYYY-MM-DD HH:mm');
      currentOd.deliveryDateTimestamp = getTimestampForMomentDate(
        deliveryDate,
        storeConfig.timeZone,
        'YYYY-MM-DD HH:mm'
      );
      currentOd.shiftId = shiftId;
      currentOd.isFutureDeliveryDate = isFutureDeliveryDate;
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: newOrder });
    }
  };

  updateVoucher = (voucher) => {
    const { currentOrder, setState } = this.props;
    if (voucher._id) {
      let currentOd = JSON.parse(JSON.stringify(currentOrder));
      currentOd.voucherId = voucher._id;
      currentOd.selectedVoucher = voucher;
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: newOrder });
      if (!newOrder.isAllowToConfirm) {
        setTimeout(() => {
          this.updateOrderStageBack();
        }, 0);
      }
    }
  };

  saveUnit = (unit) => {
    if (unit) {
      const { currentOrder, setState } = this.props;
      let currentOd = JSON.parse(JSON.stringify(currentOrder));
      currentOd.unit = unit;
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: newOrder });
    }
  };

  updatePaymenyType = (
    cardDescription,
    cardNumber,
    cardType,
    isSameCard,
    isCardDetailsValid,
    token,
    cardCountry
  ) => {
    const { storeConfig, currentOrder } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    if (isSameCard) {
      if (isCardDetailsValid) currentOd.paymentType = '2';
      else {
        currentOd.paymentType = '0';
        currentOd.cardType = '1000';
        currentOd.cardNumber = '';
        currentOd.cardDescription = '';
        currentOd.isInternationCard = false;
        currentOd.token = '';
      }
    } else {
      currentOd.paymentType = '2';
      currentOd.cardType = cardType.toString();
      currentOd.isInternationCard =
        cardCountry.toLowerCase() ===
        storeConfig.countryIdentifier.toLowerCase()
          ? false
          : true;
      currentOd.cardNumber = cardNumber;
      currentOd.cardDescription = cardDescription;
      currentOd.token = token;
    }
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
  };

  updatePaymentTypeForNewCard = (isCardDetailsValid, card) => {
    const { currentOrder, storeConfig, setState } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    if (isCardDetailsValid) {
      currentOd.paymentType = '2';
      currentOd.cardType = card.type;
      currentOd.isInternationCard =
        card.country.toLowerCase() ===
        storeConfig.countryIdentifier.toLowerCase()
          ? false
          : true;
      currentOd.cardNumber = card.number;
      currentOd.cardDescription = card.type;
    } else {
      currentOd.paymentType = '0';
      currentOd.cardNumber = '';
      currentOd.cardType = '';
      currentOd.isInternationCard = false;
      currentOd.cardDescription = '';
    }
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
  };

  updatePaymentTypeForCash = () => {
    const { currentOrder, setState } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    currentOd.paymentType = '1';
    currentOd.cardNumber = '';
    currentOd.cardType = '';
    currentOd.isInternationCard = false;
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
  };

  updatePaymentTypeForWallet = () => {
    const { currentOrder } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    currentOd.paymentType = '2';
    currentOd.cardNumber = '';
    currentOd.cardType = '';
    currentOd.isInternationCard = false;
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
  };

  updatePaymentTypeForCard = () => {
    const { currentOrder } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    if (currentOd.paymentType === '2') currentOd.paymentType = '2';
    else currentOd.paymentType = '2';
    currentOd.stage = 4.1;
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
  };

  // ~combiners~

  addToOrder = (item) => {
    const { currentOrder, setState } = this.props;
    let isItemmerged = false;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    let menuItems = currentOd.menuItems;
    let existingItems = menuItems.filter((m) => {
      return m._id === item._id;
    });
    if (existingItems && existingItems.length > 0) {
      existingItems.map((ext) => {
        if (!isItemmerged) {
          if (this.detectMergeRequired(item, ext)) {
            let mergedItem = this.performMerge(item, ext);
            menuItems = menuItems.map((menuItem) => {
              if (
                menuItem._id === item._id &&
                mergedItem.orderIndex === menuItem.orderIndex
              ) {
                return {
                  ...menuItem,
                  ...mergedItem,
                };
              }
              return {
                ...menuItem,
              };
            });
            currentOd.menuItems = menuItems;
            let newOrder = this.getOrderCalculations(currentOd);
            isItemmerged = true;
            setState({ currentOrder: newOrder });
            this.setState({
              rightSideViewVisibilityIndex: 0,
            });
          } else {
            currentOd.menuItems = [...menuItems, item];
            let newOrder = this.getOrderCalculations(currentOd);
            setState({ currentOrder: newOrder });
            this.setState({
              rightSideViewVisibilityIndex: 0,
            });
          }
        }
        return ext;
      });
    } else {
      currentOd.menuItems = [...menuItems, item];
      let newOrder = this.getOrderCalculations(currentOd);
      setState({ currentOrder: newOrder });
      this.setState({
        rightSideViewVisibilityIndex: 0,
      });
    }
    setTimeout(() => {
      this.setState({ itemInProgress: null });
    }, 0);
  };

  addTableToOrder = (table) => {
    const { currentOrder, setState } = this.props;

    const { number, id, floorLayoutId } = table;

    const newOrder = this.getOrderCalculations({
      ...currentOrder,
      orderType: `3`,
      tableNumber: number,
      tableId: id,
      floorLayoutId: floorLayoutId,
      dineInObjectId: id,
    });

    setState({ currentOrder: newOrder });
  };

  addItemsToOrder = (items) => {
    const { currentOrder, setState } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    let menuItems = currentOd.menuItems;
    items.map((item) => {
      let isItemMerged = false;
      let existingItems = currentOd.menuItems.filter((m) => {
        return m._id === item._id;
      });
      if (existingItems && existingItems.length > 0) {
        existingItems.map((ext) => {
          if (!isItemMerged) {
            if (this.detectMergeRequired(item, ext)) {
              let mergedItem = this.performMerge(item, ext);
              menuItems.map((m) => {
                if (m._id === item._id) {
                  m = { ...mergedItem };
                }
                return m;
              });
              isItemMerged = true;
            }
          }
          return ext;
        });
        if (!isItemMerged) {
          menuItems.push(item);
          isItemMerged = true;
        }
      } else {
        menuItems.push(item);
        isItemMerged = true;
      }
      return item;
    });
    currentOd.menuItems = menuItems;
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
  };

  addHalfItemsToOrder = (itemFH, itemSH, halfHalfAdditionalCharges) => {
    const { currentOrder, setState } = this.props;
    let currentOd = JSON.parse(JSON.stringify(currentOrder));
    let menuItems = currentOd.menuItems;
    let existingItems = menuItems.filter((m) => {
      return m._id === itemFH._id && m.isHalf;
    });
    let existingItemsSH = menuItems.filter((m) => {
      return m._id === itemSH._id && m.isHalf;
    });
    if (
      existingItems &&
      existingItems.length > 0 &&
      existingItemsSH &&
      existingItemsSH.length > 0
    ) {
      if (
        this.detectHalfMergeRequired(
          itemFH,
          itemSH,
          existingItems[0],
          existingItemsSH[0]
        )
      ) {
        let mergedItem = this.performMerge(itemFH, existingItems[0]);
        menuItems.map((m) => {
          if (m._id === itemFH._id) {
            m = { ...mergedItem };
          }
          return m;
        });
        let mergedItemSH = this.performMerge(itemSH, existingItemsSH[0]);
        menuItems.map((m) => {
          if (m._id === itemSH._id) {
            m = { ...mergedItemSH };
          }
          return m;
        });
      } else {
        menuItems.push(itemFH);
        menuItems.push(itemSH);
      }
    } else {
      menuItems.push(itemFH);
      menuItems.push(itemSH);
    }
    currentOd.menuItems = menuItems;
    currentOd.halfHalfAdditionalCharges = halfHalfAdditionalCharges.toFixed(2);
    let newOrder = this.getOrderCalculations(currentOd);
    setState({ currentOrder: newOrder });
  };

  addToSpecial = (item) => {
    if (this.state.specialItem && this.state.specialItem._id) {
      let newList = [];
      let itemsPresent = this.state.selectedSpecials
        ? JSON.parse(JSON.stringify(this.state.selectedSpecials))
        : [];
      let existItems = itemsPresent.some((f) => {
        return f.boxIndex === this.props.boxIndex;
      });

      if (existItems) {
        newList = itemsPresent.filter((m) => {
          return m.boxIndex !== this.props.boxIndex;
        });
      } else {
        newList = itemsPresent;
      }

      if (Array.isArray(item)) {
        // adding half-half to special
        item.forEach((i) => {
          i.specialId = this.state.specialItem._id;
          i.boxIndex = this.props.boxIndex;
          i.quantity = 0.5;
          newList.push(i);
        });
      } else {
        item.specialId = this.state.specialItem._id;
        item.boxIndex = this.props.boxIndex;
        // XXX: FIX FOR REALLY HARD SIDE-EFFECT BUG
        item.isHalf = false;
        item.quantity = 1;
        if (Array.isArray(item?.selectedSizes) && item.selectedSizes[0]) {
          item.selectedSizes[0].quantity = 1;
          item.itemPrice = parseFloat(item.selectedSizes[0].price);
          item.payablePrice = parseFloat(item.selectedSizes[0].price);
        }

        newList.push(item);
      }

      this.setState((prevState) => ({
        rightSideViewVisibilityIndex: 3,
        itemExist: -1,
        selectedSpecials: newList,
        itemInProgress: { ...prevState.itemInProgress, _id: 'specialTest' },
        orderItem: { ...prevState.orderItem, _id: 'specialTest' },
      }));
    }
  };

  addToHalfHalf = (item) => {
    let itemsPresent = JSON.parse(JSON.stringify(this.state.selectedHalfItems));
    let chargeExpensiveHalf = this.props.halfHalfSetup.chargeExpensiveHalf;
    item.whichHalf = this.state.whichHalf;
    if (itemsPresent.length < 2) itemsPresent.push(item);
    else itemsPresent[this.state.whichHalf - 1] = item;
    if (chargeExpensiveHalf) {
      let price = 0;
      //Find out price for more expensive item
      itemsPresent.forEach((item) => {
        if (item) {
          if (item.itemType === 1) {
            //Complex Item
            item.selectedModifiers.forEach((modifier) => {
              if (modifier._id === item.baseModifierId) {
                modifier.subModifiers.forEach((subModifier) => {
                  if (
                    subModifier.quantity > 0 &&
                    Number(subModifier.price) > price
                  ) {
                    price = Number(subModifier.price);
                  }
                });
              }
            });
          } else {
            //Simple Item
            item.selectedSizes.forEach((size) => {
              if (size.quantity > 0 && Number(size.price) > price) {
                price = Number(size.price);
              }
            });
          }
        }
      });

      //Update Price
      itemsPresent.forEach((item) => {
        if (item) {
          if (item.itemType === 1) {
            //Complex Item
            item.selectedModifiers.forEach((modifier) => {
              if (modifier._id === item.baseModifierId) {
                modifier.subModifiers.forEach((subModifier) => {
                  if (subModifier.quantity > 0) {
                    subModifier.price = Number(price).toFixed(2);
                  }
                });
              }
            });
          }
          item.selectedSizes.forEach((size) => {
            if (size.quantity > 0) {
              size.price = Number(price).toFixed(2);
            }
          });
        }
      });
    }
    this.setState({
      rightSideViewVisibilityIndex: 4,
      whichHalf: this.state.whichHalf === 1 ? 2 : 1,
      selectedHalfItems: itemsPresent,
    });
    setTimeout(() => {
      this.setState({
        itemInProgress: null,
      });
    }, 0);
  };

  addSpecialToOrder = (specialItem) => {
    if (
      specialItem &&
      specialItem.selectedCategories &&
      this.state.selectedSpecials
    ) {
      this.props.filterView({
        isSpecialFilterApplied: false,
        spMenuItems: [],
        spMenuSizes: [],
        spSubModifiers: [],
        spMenuCategories: [],
        boxIndex: -1,
      });

      this.setState({ rightSideViewVisibilityIndex: 0, specialItem: {} });
      let menuUnderline = document.getElementsByClassName(
        'tabsSlider--menuUnderline'
      );
      if (menuUnderline[0]) {
        menuUnderline[0].style.width = '53px';
      }

      let itemsToBeAdded = this.doASelefMerge();
      this.addItemsToOrder(itemsToBeAdded.filter(({ isHalf }) => !isHalf));

      setTimeout(() => {
        const halfItems = this.state.selectedSpecials.filter(
          ({ isHalf }) => isHalf
        );

        if (halfItems) {
          const grouped = Object.values(
            halfItems.reduce(
              (acc, item) => ({
                ...acc,
                [item.boxIndex]: [
                  ...(acc[item.boxIndex] || []),
                  {
                    ...item,
                    halfIndex: item.halfIndex + item.boxIndex,
                  },
                ],
              }),
              {}
            )
          );

          for (const [FH, SH] of grouped) {
            if (FH && SH) {
              this.addHalfItemsToOrder(FH, SH, 0);
            } else if (!SH) {
              this.addItemsToOrder([{ ...FH, quantity: 1, isHalf: false }]);
            } else if (!FH && SH) {
              this.addItemsToOrder([{ ...SH, quantity: 1, isHalf: false }]);
            }
          }
        }
      }, 300);
    }
  };

  incrementItemQuantity = (sizeObj, itemObj, whichHalf) => {
    const { currentOrder, setState } = this.props;
    let ctOrder = JSON.parse(JSON.stringify(currentOrder));
    let menuItem = ctOrder.menuItems.filter((menuItem) => {
      return (
        menuItem._id === itemObj._id &&
        itemObj.orderIndex === menuItem.orderIndex
      );
    });
    if (itemObj.isHalf) {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        currentItem.selectedSizes.map((item) => {
          if (item._id === sizeObj._id) {
            if (item.quantity) {
              item.quantity = item.quantity + 0.5;
            } else {
              item.quantity = 0.5;
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity) {
                  v.quantity = v.quantity + 0.5;
                }
                return v;
              });
            }
          }
          return item;
        });

        // increase global menu item quantity
        currentItem.quantity = currentItem.quantity + 0.5;

        // Complex item
        if (currentItem.itemType === 1) {
          currentItem.selectedModifiers.map((modifier) => {
            if (modifier._id === currentItem.baseModifierId) {
              modifier.subModifiers.map((s) => {
                if (s._id === sizeObj._id) {
                  if (s.quantity) {
                    s.quantity = s.quantity + 0.5;
                  } else {
                    s.quantity = 0.5;
                  }
                }
                return s;
              });
            } else {
              modifier.subModifiers.map((s) => {
                if (s.prices) {
                  s.prices.map((p) => {
                    if (p.quantity) p.quantity = p.quantity + 0.5;
                    else p.quantity = 1;
                    if (p.variants) {
                      p.variants.map((v) => {
                        if (v.quantity) v.quantity = v.quantity + 0.5;
                        else v.quantity = 1;
                        return v;
                      });
                    }
                    return p;
                  });
                }
                return s;
              });
            }
            return modifier;
          });
        }
        ctOrder.menuItems.map((m) => {
          if (m._id === currentItem._id) {
            m = currentItem;
          }
          return m;
        });
        let itemsSF = ctOrder.menuItems.filter((menuItem) => {
          return (
            menuItem._id !== currentItem._id &&
            itemObj.halfIndex === menuItem.halfIndex
          );
        });
        if (itemsSF && itemsSF.length > 0) {
          let ctM = itemsSF[0];
          ctM.selectedSizes.map((item) => {
            // if (item._id === sizeObj._id) {
            if (item.quantity) {
              item.quantity = item.quantity + 0.5;
            } else {
              item.quantity = 0.5;
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity) {
                  v.quantity = v.quantity + 0.5;
                }
                return v;
              });
            }
            // }
            return item;
          });

          // increase global menu item quantity
          ctM.quantity = currentItem.quantity + 0.5;

          // Complex item
          if (ctM.itemType === 1) {
            ctM.selectedModifiers.map((modifier) => {
              if (modifier._id === ctM.baseModifierId) {
                modifier.subModifiers.map((s) => {
                  if (s._id === sizeObj._id) {
                    if (s.quantity) {
                      s.quantity = s.quantity + 0.5;
                    } else {
                      s.quantity = 0.5;
                    }
                  }
                  return s;
                });
              } else {
                modifier.subModifiers.map((s) => {
                  if (s.prices) {
                    s.prices.map((p) => {
                      if (p.quantity) p.quantity = p.quantity + 0.5;
                      else p.quantity = 1;
                      if (p.variants) {
                        p.variants.map((v) => {
                          if (v.quantity) v.quantity = v.quantity + 0.5;
                          else v.quantity = 1;
                          return v;
                        });
                      }
                      return p;
                    });
                  }
                  return s;
                });
              }
              return modifier;
            });
          }
          ctOrder.menuItems.map((m) => {
            if (m._id === ctM._id) {
              m = ctM;
            }
            return m;
          });
        }
        let charges = currentOrder.halfHalfAdditionalCharges
          ? Number(currentOrder.halfHalfAdditionalCharges)
          : 0;
        let negCharges =
          this.props.halfHalfSetup &&
          this.props.halfHalfSetup.halfHalfAdditionalCharges
            ? Number(this.props.halfHalfSetup.halfHalfAdditionalCharges)
            : 0;
        charges = charges + negCharges;
        ctOrder.halfHalfAdditionalCharges = charges.toFixed(2);
        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    } else {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        currentItem.selectedSizes.map((item) => {
          if (item._id === sizeObj._id) {
            if (item.quantity) {
              item.quantity = item.quantity + 1;
            } else {
              item.quantity = 1;
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity) {
                  v.quantity = v.quantity + 1;
                }
                return v;
              });
            }
          }
          return item;
        });

        // increase global menu item quantity
        currentItem.quantity = currentItem.quantity + 1;

        // Complex item
        if (itemObj.itemType === 1) {
          currentItem = currentItem.selectedModifiers.map((modifier) => {
            if (modifier._id === currentItem.baseModifierId) {
              modifier.subModifiers.map((s) => {
                if (s._id === sizeObj._id) {
                  if (s.quantity) {
                    s.quantity = s.quantity + 1;
                  } else {
                    s.quantity = 1;
                  }
                  if (s.variants) {
                    s.variants.map((v) => {
                      if (v.quantity) v.quantity = v.quantity + 1;
                      else v.quantity = 1;
                      return v;
                    });
                  }
                }
                return s;
              });
            } else {
              modifier.subModifiers.map((s) => {
                if (s.prices) {
                  s.prices.map((p) => {
                    if (p.quantity) p.quantity = p.quantity + 1;
                    else p.quantity = 1;
                    if (p.variants) {
                      p.variants.map((v) => {
                        if (v.quantity) v.quantity = v.quantity + 1;
                        else v.quantity = 1;
                        return v;
                      });
                    }
                    return p;
                  });
                }
                return s;
              });
            }
            return modifier;
          });
        }
        const itemPrice = Number(this.getItemPrice(currentItem));
        currentItem.itemPrice = itemPrice;
        currentItem.payablePrice = itemPrice;
        ctOrder.menuItems.map((m) => {
          if (m._id === currentItem._id) {
            m = currentItem;
          }
          return m;
        });

        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    }
  };

  incrementExtraQuantity = (extraObj, itemObj, whichHalf) => {
    const { currentOrder, setState } = this.props;
    let ctOrder = JSON.parse(JSON.stringify(currentOrder));
    let menuItem = ctOrder.menuItems.filter((menuItem) => {
      return (
        menuItem._id === itemObj._id &&
        itemObj.orderIndex === menuItem.orderIndex
      );
    });
    if (itemObj.isHalf) {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        if (whichHalf === '1') {
          currentItem.selectedExtraIngredients.map((item) => {
            if (item._id === extraObj._id) {
              if (item.quantity) {
                item.quantity = item.quantity + 1;
              } else {
                item.quantity = 1;
              }
            }
            return item;
          });
          ctOrder.menuItems.map((m) => {
            if (m._id === currentItem._id) {
              m = currentItem;
            }
            return m;
          });
        }
        if (whichHalf === '2') {
          let itemsSF = ctOrder.menuItems.filter((menuItem) => {
            return (
              menuItem._id !== currentItem._id &&
              itemObj.halfIndex === menuItem.halfIndex
            );
          });
          if (itemsSF && itemsSF.length > 0) {
            let ctM = itemsSF[0];
            ctM.selectedExtraIngredients.map((item) => {
              if (item._id === extraObj._id) {
                if (item.quantity) {
                  item.quantity = item.quantity + 1;
                } else {
                  item.quantity = 1;
                }
              }
              return item;
            });
            ctOrder.menuItems.map((m) => {
              if (m._id === ctM._id) {
                m = ctM;
              }
              return m;
            });
          }
        }
        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    } else {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        currentItem.selectedExtraIngredients.map((item) => {
          if (item._id === extraObj._id) {
            if (item.quantity) {
              item.quantity = item.quantity + 1;
            } else {
              item.quantity = 1;
            }
          }
          return item;
        });
        ctOrder.menuItems.map((m) => {
          if (m._id === currentItem._id) {
            m = currentItem;
          }
          return m;
        });
        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    }
  };

  decrementItemQuantity = (sizeObj, itemObj, whichHalf) => {
    const { currentOrder, setState } = this.props;
    let ctOrder = JSON.parse(JSON.stringify(currentOrder));
    let menuItem = ctOrder.menuItems.filter((menuItem) => {
      return (
        menuItem._id === itemObj._id &&
        itemObj.orderIndex === menuItem.orderIndex
      );
    });
    if (itemObj.isHalf) {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        currentItem.selectedSizes.map((item) => {
          if (item._id === sizeObj._id) {
            if (item.quantity) {
              item.quantity = item.quantity - 0.5;
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity) {
                  v.quantity = v.quantity - 0.5;
                }
                return v;
              });
            }
          }
          return item;
        });

        //symotion-prefix) decrease global menu item quantity
        currentItem.quantity = currentItem.quantity - 0.5;

        // Complex item
        if (currentItem.itemType === 1) {
          currentItem.selectedModifiers.map((modifier) => {
            if (modifier._id === currentItem.baseModifierId) {
              modifier.subModifiers.map((s) => {
                if (s._id === sizeObj._id) {
                  if (s.quantity) s.quantity = s.quantity - 0.5;
                  else s.quantity = 0;
                  if (s.variants) {
                    s.variants.map((v) => {
                      if (v.quantity) v.quantity = v.quantity - 0.5;
                      else v.quantity = 0;
                      return v;
                    });
                  }
                }
                return s;
              });
            } else {
              modifier.subModifiers.map((s) => {
                if (s.prices) {
                  s.prices.map((p) => {
                    if (p.quantity) p.quantity = p.quantity - 0.5;
                    else p.quantity = 0;
                    if (p.variants) {
                      p.variants.map((v) => {
                        if (v.quantity) v.quantity = v.quantity - 0.5;
                        else v.quantity = 0;
                        return v;
                      });
                    }
                    return p;
                  });
                }
                return s;
              });
            }
            return modifier;
          });
        }
        currentItem.selectedSizes = currentItem.selectedSizes.filter((s) => {
          return s.quantity && Number(s.quantity) > 0;
        });
        ctOrder.menuItems.map((m) => {
          if (m._id === currentItem._id) {
            m = currentItem;
          }
          return m;
        });

        let itemsSF = ctOrder.menuItems.filter((menuItem) => {
          return (
            menuItem.whichHalf !== itemObj.whichHalf &&
            itemObj.halfIndex === menuItem.halfIndex
          );
        });

        if (itemsSF && itemsSF.length > 0) {
          let ctM = itemsSF[0];
          ctM.selectedSizes.map((item) => {
            if (item.quantity) {
              item.quantity = item.quantity - 0.5;
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity) {
                  v.quantity = v.quantity - 0.5;
                }
                return v;
              });
            }
            return item;
          });

          // decrease global menu item quantity
          ctM.quantity = ctM.quantity - 1;

          // Complex item
          if (ctM.itemType === 1) {
            ctM.selectedModifiers.map((modifier) => {
              if (modifier._id === ctM.baseModifierId) {
                modifier.subModifiers.map((s) => {
                  if (s._id === sizeObj._id) {
                    if (s.quantity) s.quantity = s.quantity - 0.5;
                    else s.quantity = 0;
                    if (s.variants) {
                      s.variants.map((v) => {
                        if (v.quantity) v.quantity = v.quantity - 0.5;
                        else v.quantity = 0;
                        return v;
                      });
                    }
                  }
                  return s;
                });
              } else {
                modifier.subModifiers.map((s) => {
                  if (s.prices) {
                    s.prices.map((p) => {
                      if (p.quantity) p.quantity = p.quantity - 0.5;
                      else p.quantity = 0;
                      if (p.variants) {
                        p.variants.map((v) => {
                          if (v.quantity) v.quantity = v.quantity - 0.5;
                          else v.quantity = 0;
                          return v;
                        });
                      }
                      return p;
                    });
                  }
                  return s;
                });
              }
              return modifier;
            });
          }
          ctM.selectedSizes = ctM.selectedSizes.filter((s) => {
            return s.quantity && Number(s.quantity) > 0;
          });

          ctOrder.menuItems.map((m) => {
            if (m._id === ctM._id) {
              m = ctM;
            }
            return m;
          });
        }
        let charges = currentOrder.halfHalfAdditionalCharges
          ? Number(currentOrder.halfHalfAdditionalCharges)
          : 0;
        let negCharges =
          this.props.halfHalfSetup &&
          this.props.halfHalfSetup.halfHalfAdditionalCharges
            ? Number(this.props.halfHalfSetup.halfHalfAdditionalCharges)
            : 0;
        charges = charges !== 0 ? charges - negCharges : 0;
        ctOrder.halfHalfAdditionalCharges = charges.toFixed(2);
        ctOrder.menuItems = ctOrder.menuItems.filter((m) => {
          return m.selectedSizes && m.selectedSizes.length > 0;
        });
        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    } else {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        currentItem.selectedSizes.map((item) => {
          if (item._id === sizeObj._id) {
            if (item.quantity) {
              item.quantity = item.quantity - 1;
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity) {
                  v.quantity = v.quantity - 1;
                }
                return v;
              });
            }
          }
          return item;
        });
        currentItem.selectedSizes = currentItem.selectedSizes.filter((s) => {
          return s.quantity && Number(s.quantity) > 0;
        });

        // decrease global menu item quantity
        currentItem.quantity = currentItem.quantity - 1;

        // Complex item
        if (itemObj.itemType === 1) {
          currentItem.selectedModifiers.map((modifier) => {
            if (modifier._id === currentItem.baseModifierId) {
              modifier.subModifiers.map((s) => {
                if (s._id === sizeObj._id) {
                  if (s.quantity) s.quantity = s.quantity - 1;
                  else s.quantity = 0;
                  if (s.variants) {
                    s.variants.map((v) => {
                      if (v.quantity) v.quantity = v.quantity - 1;
                      else v.quantity = 0;
                      return v;
                    });
                  }
                }
                return s;
              });
            } else {
              modifier.subModifiers.map((s) => {
                if (s.prices) {
                  s.prices.map((p) => {
                    if (p.quantity) p.quantity = p.quantity - 1;
                    else p.quantity = 0;
                    if (p.variants) {
                      p.variants.map((v) => {
                        if (v.quantity) v.quantity = v.quantity - 1;
                        else v.quantity = 0;
                        return v;
                      });
                    }
                    return p;
                  });
                }
                return s;
              });
            }
            return modifier;
          });
        }

        const itemPrice = Number(this.getItemPrice(currentItem));
        currentItem.itemPrice = itemPrice;
        currentItem.payablePrice = itemPrice;

        ctOrder.menuItems.map((m) => {
          if (m._id === currentItem._id) {
            m = currentItem;
          }
          return m;
        });

        ctOrder.menuItems = ctOrder.menuItems.filter((m) => {
          return m.selectedSizes && m.selectedSizes.length > 0;
        });
        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    }
  };

  decrementExtraQuantity = (extraObj, itemObj, whichHalf) => {
    const { currentOrder, setState } = this.props;
    let ctOrder = JSON.parse(JSON.stringify(currentOrder));
    let menuItem = ctOrder.menuItems.filter((menuItem) => {
      return (
        menuItem._id === itemObj._id &&
        itemObj.orderIndex === menuItem.orderIndex
      );
    });
    if (itemObj.isHalf) {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        if (whichHalf === '1') {
          currentItem.selectedExtraIngredients.map((item) => {
            if (item._id === extraObj._id) {
              if (item.quantity) {
                item.quantity = item.quantity - 1;
              }
            }
            return item;
          });
          currentItem.selectedExtraIngredients =
            currentItem.selectedExtraIngredients.filter((s) => {
              return s.quantity && Number(s.quantity) > 0;
            });
          ctOrder.menuItems.map((m) => {
            if (m._id === currentItem._id) {
              m = currentItem;
            }
            return m;
          });
        }
        if (whichHalf === '2') {
          let itemsSF = ctOrder.menuItems.filter((menuItem) => {
            return (
              menuItem._id !== itemObj._id &&
              itemObj.halfIndex === menuItem.halfIndex
            );
          });
          if (itemsSF && itemsSF.length > 0) {
            let ctM = itemsSF[0];
            ctM.selectedExtraIngredients.map((item) => {
              if (item._id === extraObj._id) {
                if (item.quantity) {
                  item.quantity = item.quantity - 1;
                }
              }
              return item;
            });
            ctM.selectedExtraIngredients = ctM.selectedExtraIngredients.filter(
              (s) => {
                return s.quantity && Number(s.quantity) > 0;
              }
            );
            ctOrder.menuItems.map((m) => {
              if (m._id === ctM._id) {
                m = ctM;
              }
              return m;
            });
          }
        }
        ctOrder.menuItems = this.reMergeHalfItems(ctOrder.menuItems, itemObj);
        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    } else {
      if (menuItem && menuItem.length > 0) {
        let currentItem = menuItem[0];
        currentItem.selectedExtraIngredients.map((item) => {
          if (item._id === extraObj._id) {
            if (item.quantity) {
              item.quantity = item.quantity - 1;
            }
          }
          return item;
        });
        if (currentItem.selectedExtraIngredients) {
          currentItem.selectedExtraIngredients =
            currentItem.selectedExtraIngredients.filter((m) => {
              return m.quantity && Number(m.quantity) > 0;
            });
        }
        ctOrder.menuItems.map((m) => {
          if (m._id === currentItem._id) {
            m = currentItem;
          }
          return m;
        });
        ctOrder.menuItems = this.reMergeItems(ctOrder.menuItems, currentItem);
        let newOrder = this.getOrderCalculations(ctOrder);
        setState({ currentOrder: newOrder });
      }
    }
  };

  // ~half/half~

  getNextHalfIndex = () => {
    const { currentOrder } = this.props;
    const halfItems = currentOrder.menuItems.filter((i) => i.isHalf);
    const currentIndexes = halfItems.map((i) => i.halfIndex);
    const ret = currentIndexes.length ? Math.max(...currentIndexes) + 1 : 0;
    return ret;
  };

  clearItemsNotAvailableForVariants = (itemVariants) => {
    this.setState({ selectedHalfItems: [], itemVariants });
  };

  addHalfHalfToOrder = () => {
    const { currentOrder } = this.props;
    if (
      this.state.selectedHalfItems &&
      this.state.selectedHalfItems.length >= 2
    ) {
      let halfIndex = this.getNextHalfIndex();

      let firstItem = JSON.parse(
        JSON.stringify(this.state.selectedHalfItems[0])
      );

      if (this.state.itemVariants && this.state.itemVariants.length > 0) {
        firstItem.selectedSizes = firstItem.selectedSizes.map((s) => {
          if (s.variants) {
            s.variants.map((v) => {
              if (v.isSelected) {
                let matchingVariants = this.state.itemVariants.filter((vv) => {
                  return vv._id === v._id;
                });
                if (matchingVariants.length > 0) {
                  v.quantity = s.quantity;
                  v.isSelected = true;
                } else {
                  v.isSelected = false;
                  v.quantity = 0;
                }
              } else {
                v.isSelected = false;
                v.quantity = 0;
              }
              return v;
            });
          }
          return s;
        });
      } else {
        firstItem.selectedSizes = firstItem.selectedSizes.map((s) => {
          if (Array.isArray(s.variants)) {
            s.variants.forEach((v) => {
              v.isSelected = false;
              v.quantity = 0;
            });
          }
          return s;
        });
      }

      firstItem.halfIndex = halfIndex;
      firstItem.isSecondHalf = false;

      let secondItem = JSON.parse(
        JSON.stringify(this.state.selectedHalfItems[1])
      );

      if (this.state.itemVariants && this.state.itemVariants.length > 0) {
        secondItem.selectedSizes = secondItem.selectedSizes.map((s) => {
          if (s.variants) {
            s.variants.map((v) => {
              if (v.isSelected) {
                let matchingVariants = this.state.itemVariants.filter((vv) => {
                  return vv._id === v._id;
                });
                if (matchingVariants.length > 0) {
                  v.quantity = s.quantity;
                  v.isSelected = true;
                } else {
                  v.isSelected = false;
                  v.quantity = 0;
                }
              } else {
                v.isSelected = false;
                v.quantity = 0;
              }
              return v;
            });
          }
          return s;
        });
      } else {
        secondItem.selectedSizes = secondItem.selectedSizes.map((s) => {
          if (Array.isArray(s.variants)) {
            s.variants.forEach((v) => {
              v.isSelected = false;
              v.quantity = 0;
            });
          }
          return s;
        });
      }

      secondItem.halfIndex = halfIndex;
      secondItem.isSecondHalf = true;

      let charges = currentOrder.halfHalfAdditionalCharges
        ? Number(currentOrder.halfHalfAdditionalCharges)
        : 0;
      let newCharges =
        this.props.halfHalfSetup &&
        this.props.halfHalfSetup.halfHalfAdditionalCharges
          ? Number(this.props.halfHalfSetup.halfHalfAdditionalCharges) +
            Number(charges)
          : Number(charges);

      if (this.props.isSpecialFilterApplied) {
        this.setState({
          rightSideViewVisibilityIndex: 3,
          halfItem: {},
          itemVariants: [],
        });
        this.addToSpecial([firstItem, secondItem]);
      } else {
        this.setState(
          {
            rightSideViewVisibilityIndex: 0,
            halfItem: {},
            itemVariants: [],
          },
          () => {
            let menuUnderline = document.getElementsByClassName(
              'tabsSlider--menuUnderline'
            );
            if (menuUnderline[0]) {
              menuUnderline[0].style.width = '53px';
            }

            // add global menu item quantity field
            firstItem.quantity = 0.5;
            secondItem.quantity = 0.5;

            this.addHalfItemsToOrder(firstItem, secondItem, newCharges);
            this.props.history.replace('/category/popular');
          }
        );
      }
    }
  };

  // ~mergers~

  doASelefMerge = () => {
    let mergedItems = [],
      specialIndexIds = [];
    let itemsPresent = this.state.selectedSpecials
      ? JSON.parse(JSON.stringify(this.state.selectedSpecials))
      : [];
    itemsPresent.map((item, i) => {
      if (!includes(specialIndexIds, item.boxIndex)) {
        let otherItemsPresent = itemsPresent.filter((m) => {
          return (
            m._id === item._id && m.boxIndex !== item.boxIndex && !m.isHalf
          );
        });
        if (otherItemsPresent.length > 0) {
          let mergedItemIntermidient = item;
          otherItemsPresent.map((ot, index) => {
            if (this.detectMergeRequired(ot, mergedItemIntermidient)) {
              index === 0
                ? (mergedItemIntermidient = this.performMerge(ot, item))
                : (mergedItemIntermidient = this.performMerge(
                    ot,
                    mergedItemIntermidient
                  ));
              specialIndexIds.push(ot.boxIndex);
            }
            return ot;
          });
          mergedItems.push(mergedItemIntermidient);
        } else if (item.isHalf && !item.isSecondHalf) {
          const anotherHalf = itemsPresent[i + 1];

          if (anotherHalf && anotherHalf.isSecondHalf) {
            item.halfIndex = i;
            anotherHalf.halfIndex = i;
            mergedItems.push(item);
            mergedItems.push(anotherHalf);
          }
        } else if (!item.isHalf) {
          mergedItems.push(item);
        }
      }
      return item;
    });
    return mergedItems;
  };

  reMergeItems = (menuItems, currentItem) => {
    let items = menuItems;
    let mergedIndexes = false;
    menuItems.map((m) => {
      if (
        m._id === currentItem._id &&
        currentItem.orderIndex !== m.orderIndex &&
        !mergedIndexes
      ) {
        if (this.detectMergeRequired(currentItem, m)) {
          m = this.performMerge(currentItem, m);
          mergedIndexes = true;
        }
      }
      return m;
    });
    if (mergedIndexes) {
      items = menuItems.filter((f) => {
        return f.orderIndex !== currentItem.orderIndex;
      });
    }
    return items;
  };

  reMergeHalfItems = (menuItems, firstHalf) => {
    let items = menuItems;
    let mergedIndexes = false;
    let secondHalfs = menuItems.filter((o) => {
      return o._id === firstHalf._idHalf;
    });
    menuItems.map((m) => {
      if (
        m._id === firstHalf._id &&
        firstHalf.halfIndex !== m.halfIndex &&
        !mergedIndexes &&
        secondHalfs.length > 0
      ) {
        let secondHalf = secondHalfs[0];
        let existingItemsSH = menuItems.filter((o) => {
          return (
            o._id === secondHalf._id && o.halfIndex !== secondHalf.halfIndex
          );
        });
        if (
          existingItemsSH.length &&
          this.detectHalfMergeRequired(
            firstHalf,
            secondHalf,
            m,
            existingItemsSH[0]
          )
        ) {
          let ff = this.performMerge(firstHalf, m);
          mergedIndexes = true;
          items.map((i) => {
            if (i._id === ff._id) {
              i = { ...ff };
            }
            return i;
          });
          let ss = this.performMerge(secondHalf, existingItemsSH[0]);
          items.map((i) => {
            if (i._id === ss._id) {
              i = { ...ss };
            }
            return i;
          });
        }
      }
      return m;
    });
    if (mergedIndexes) {
      items = items.filter((f) => {
        return f.halfIndex !== firstHalf.halfIndex;
      });
    }
    return items;
  };

  performMerge = (newItem, existingItem) => {
    let existingItemObj = { ...existingItem };
    if (newItem.itemType === 1) {
      existingItemObj = {
        ...existingItem,
        selectedSizes: existingItem.selectedSizes?.map((size) => {
          let newItmHasIt = newItem.selectedSizes?.find((s) => {
            return s._id === size._id;
          });
          if (newItmHasIt?.quantity) {
            return {
              ...size,
              quantity:
                Number(size.quantity ? size.quantity : 0) +
                Number(newItmHasIt.quantity),
              variants: size.variants?.map((v) => {
                let newItemVariant = newItmHasIt.variants?.find(
                  (nv) => nv.quantity
                );
                return {
                  ...v,
                  quantity:
                    Number(v.quantity || 0) +
                    Number(newItemVariant?.quantity || 0),
                };
              }),
            };
          }
          return { ...size };
        }),
        selectedModifiers: existingItem.selectedModifiers?.map((m) => {
          const newItemSelectedModifier = newItem.selectedModifiers?.find(
            (modifier) => modifier._id === m._id
          );
          return {
            ...m,
            subModifiers: m.subModifiers?.map((s) => {
              const newItemSubModifier =
                newItemSelectedModifier?.subModifiers?.find(
                  (sm) => sm._id === s._id
                );
              return {
                ...s,
                quantity:
                  Number(s.quantity ? s.quantity : 0) +
                  Number(newItemSubModifier?.quantity || 0),
                variants: s.variants?.map((v) => {
                  const newItemVariant = newItemSubModifier?.variants?.find(
                    (nv) => nv._id === v._id
                  );
                  return {
                    ...v,
                    quantity:
                      Number(v.quantity || 0) +
                      Number(newItemVariant?.quantity || 0),
                  };
                }),
                prices: s.prices?.map((price) => {
                  const newItemPrice = newItemSubModifier?.prices?.find(
                    (np) => np._id === price._id
                  );
                  return {
                    ...price,
                    quantity:
                      Number(price.quantity || 0) +
                      Number(newItemPrice?.quantity || 0),
                    variants: price.variants?.map((pv) => {
                      const newPriceVariant = newItemPrice?.variants?.find(
                        (npv) => npv._id === pv._id
                      );
                      return {
                        ...pv,
                        quantity:
                          Number(pv.quantity || 0) +
                          Number(newPriceVariant?.quantity || 0),
                      };
                    }),
                  };
                }),
              };
            }),
          };
        }),
      };
    } else {
      existingItemObj = {
        ...existingItem,
        selectedSizes: existingItem.selectedSizes?.map((size) => {
          let newItmHasIt = newItem.selectedSizes?.find((s) => {
            return s._id === size._id;
          });
          if (newItmHasIt?.quantity) {
            return {
              ...size,
              quantity:
                Number(size.quantity ? size.quantity : 0) +
                Number(newItmHasIt.quantity),
              variants: size.variants?.map((v) => {
                let newItemVariant = newItmHasIt.variants?.find(
                  (nv) => nv.quantity
                );
                return {
                  ...v,
                  quantity:
                    Number(v.quantity || 0) +
                    Number(newItemVariant?.quantity || 0),
                };
              }),
            };
          }
          return { ...size };
        }),
      };
      // irrelevant - not using for now
      if (newItem.selectedSizes) {
        newItem.selectedSizes.map((size) => {
          let newItmHasIt = existingItemObj.selectedSizes.filter((s) => {
            return s._id === size._id;
          });
          if (
            newItmHasIt &&
            newItmHasIt.length > 0 &&
            newItmHasIt[0].quantity
          ) {
            //size.quantity = Number(size.quantity ? size.quantity : 0) + Number(newItmHasIt[0].quantity);
          } else {
            existingItemObj.selectedSizes.push(size);
          }
          return size;
        });
      }

      if (newItem.specialId) {
        existingItemObj.specialId = newItem.specialId;
      }
    }

    // update discount object only if its exist and not equal
    if (
      isObjectNotEmpty(newItem.selectedDiscount) &&
      isObjectNotEmpty(existingItemObj.selectedDiscount) &&
      existingItemObj.selectedDiscount._id !== newItem.selectedDiscount._id
    ) {
      existingItemObj.selectedDiscount = newItem.selectedDiscount;
    }

    existingItemObj.itemPrice = newItem.itemPrice;
    existingItemObj.extraPrice = newItem.extraPrice;
    existingItemObj.payablePrice = newItem.payablePrice;
    existingItemObj.quantity = existingItemObj.quantity + newItem.quantity;

    return existingItemObj;
  };

  detectMergeRequired = (newItem, existingItem) => {
    let diffCount = 0;
    if (newItem.itemType === 1) {
      if (newItem.baseModifierId !== existingItem.baseModifierId) {
        diffCount++;
      }
      if (newItem.selectedModifiers && existingItem.selectedModifiers) {
        let x = newItem.selectedModifiers;
        let y = existingItem.selectedModifiers;
        if (!this.isArrayEqualModifiers(x, y)) {
          diffCount++;
        }
      }
      if (newItem.removedIngredients && existingItem.removedIngredients) {
        let x = newItem.removedIngredients;
        let y = existingItem.removedIngredients;
        if (this.isDifferent(x, y)) {
          diffCount++;
        }
      }
      if (
        newItem.selectedExtraIngredients &&
        existingItem.selectedExtraIngredients
      ) {
        let x = newItem.selectedExtraIngredients;
        let y = existingItem.selectedExtraIngredients;
        if (!this.isArrayEqualExtras(x, y)) {
          diffCount++;
        }
      }
      if (
        (newItem.isHalf && !existingItem.isHalf) ||
        (!newItem.isHalf && existingItem.isHalf)
      ) {
        diffCount++;
      }
    } else {
      /* if (newItem.removedIngredients && existingItem.removedIngredients) {
        let x = newItem.removedIngredients;
        let y = existingItem.removedIngredients;
        if (this.isDifferent(x, y)) {
          diffCount++;
        }
      } */
      if (newItem.selectedSizes && existingItem.selectedSizes) {
        let x = newItem.selectedSizes;
        let y = existingItem.selectedSizes;
        if (!this.isArrayEqualSizes(x, y)) {
          diffCount++;
        }
      }
      if (
        newItem.selectedExtraIngredients &&
        existingItem.selectedExtraIngredients
      ) {
        let x = newItem.selectedExtraIngredients;
        let y = existingItem.selectedExtraIngredients;
        if (!this.isArrayEqualExtras(x, y)) {
          diffCount++;
        }
      }
      if (
        (newItem.isHalf && !existingItem.isHalf) ||
        (!newItem.isHalf && existingItem.isHalf)
      ) {
        diffCount++;
      }
    }
    if (diffCount !== 0) {
      return false;
    }
    return true;
  };

  detectHalfMergeRequired = (
    newItemFH,
    newItemSH,
    existingItemFH,
    existingItemSH
  ) => {
    let diffCount = 0;
    if (newItemFH.removedIngredients && existingItemFH.removedIngredients) {
      let x = newItemFH.removedIngredients;
      let y = existingItemFH.removedIngredients;
      if (this.isDifferent(x, y)) {
        diffCount++;
      }
    }
    if (newItemFH.selectedSizes && existingItemFH.selectedSizes) {
      let x = newItemFH.selectedSizes;
      let y = existingItemFH.selectedSizes;
      if (!this.isArrayEqualSizes(x, y)) {
        diffCount++;
      }
    }
    if (
      newItemFH.selectedExtraIngredients &&
      existingItemFH.selectedExtraIngredients
    ) {
      let x = newItemFH.selectedExtraIngredients;
      let y = existingItemFH.selectedExtraIngredients;
      if (!this.isArrayEqualExtras(x, y)) {
        diffCount++;
      }
    }
    if (
      (newItemFH.isHalf && !existingItemFH.isHalf) ||
      (!newItemFH.isHalf && existingItemFH.isHalf)
    ) {
      diffCount++;
    }
    if (newItemSH.removedIngredients && existingItemSH.removedIngredients) {
      let x = newItemSH.removedIngredients;
      let y = existingItemSH.removedIngredients;
      if (!this.isDifferent(x, y)) {
        diffCount++;
      }
    }
    if (newItemSH.selectedSizes && existingItemSH.selectedSizes) {
      let x = newItemSH.selectedSizes;
      let y = existingItemSH.selectedSizes;
      if (!this.isArrayEqualSizes(x, y)) {
        diffCount++;
      }
    }
    if (newItemSH.selectedSizes && existingItemSH.selectedSizes) {
      let x = newItemSH.selectedSizes;
      let y = existingItemSH.selectedSizes;
      if (!this.isArrayEqualSizes(x, y)) {
        diffCount++;
      }
    }
    if (
      newItemSH.selectedExtraIngredients &&
      existingItemSH.selectedExtraIngredients
    ) {
      let x = newItemSH.selectedExtraIngredients;
      let y = existingItemSH.selectedExtraIngredients;
      if (!this.isArrayEqualExtras(x, y)) {
        diffCount++;
      }
    }
    if (
      (newItemSH.isHalf && !existingItemSH.isHalf) ||
      (!newItemSH.isHalf && existingItemSH.isHalf)
    ) {
      diffCount++;
    }
    if (diffCount !== 0) {
      return false;
    }
    return true;
  };

  // ~utils~

  isArrayEqualModifiers = (x, y) => {
    if (x.length !== y.length) return false;
    else {
      let xx = orderBy(JSON.parse(JSON.stringify(x)), 'displayOrder');
      let yy = orderBy(JSON.parse(JSON.stringify(y)), 'displayOrder');
      let xString = '',
        yString = '';
      xx.map((i) => {
        xString = xString + i.name;
        i.subModifiers &&
          i.subModifiers.map((s) => {
            xString = xString + s.name;
            s.variants &&
              s.variants.map((v) => {
                xString = xString + v.name;
                return v;
              });
            return s;
          });
        return i;
      });
      yy.map((i) => {
        yString = yString + i.name;
        i.subModifiers &&
          i.subModifiers.map((s) => {
            yString = yString + s.name;
            s.variants &&
              s.variants.map((v) => {
                yString = yString + v.name;
                return v;
              });
            return s;
          });
        return i;
      });
      if (
        xString.length !== 0 &&
        yString.length !== 0 &&
        xString.toLowerCase() === yString.toLowerCase()
      )
        return true;
      else return false;
    }
  };

  isArrayEqualSizes = (x, y) => {
    if (x.length !== y.length) return false;
    else {
      let newArrLength = x.length;
      let oldArrEqilength = 0;
      x.map((i) => {
        let isINy = y.filter((m) => {
          let diff = 0;
          if (m._id === i._id) {
            if (
              i.variants &&
              m.variants &&
              i.variants.length === m.variants.length
            ) {
              i.variants.map((iv) => {
                if (m.variants) {
                  let matchingVariants = m.variants.filter((mv) => {
                    return iv._id === mv._id && iv.quantity === mv.quantity;
                  });
                  if (matchingVariants.length <= 0) diff = diff + 1;
                } else {
                  diff = diff + 1;
                }
                return iv;
              });
            } else diff = diff + 1;
          } else diff = diff + 1;
          return diff === 0;
        });
        if (isINy.length > 0) {
          oldArrEqilength = oldArrEqilength + 1;
        }
        return i;
      });
      if (newArrLength === oldArrEqilength) return true;
      else return false;
    }
  };

  isArrayEqualExtras = (x, y) => {
    if (x.length !== y.length) return false;
    else {
      let newArrLength = x.length;
      let oldArrEqilength = 0;
      x.map((i) => {
        let isINy = y.filter((m) => {
          return (
            m._id === i._id &&
            m.sizeId === i.sizeId &&
            m.variantId === i.variantId &&
            m.quantity === i.quantity
          );
        });
        if (isINy.length > 0) {
          oldArrEqilength = oldArrEqilength + 1;
        }
        return i;
      });
      if (newArrLength === oldArrEqilength) return true;
      else return false;
    }
  };

  isDifferent = (x, y) => {
    return x.some((i) => y.findIndex((k) => i._id === k._id) !== -1);
  };

  getItemsInCart = (currentOd) => {
    let itemsInCart = [];
    let menuItems = currentOd.menuItems
      ? JSON.parse(JSON.stringify(currentOd.menuItems))
      : [];
    if (menuItems.length > 0) {
      menuItems.map((m) => {
        if (m.selectedSizes && m.selectedSizes.length > 0 && !m.isHalf) {
          m.selectedSizes.map((s) => {
            if (s.quantity) {
              let qan = Number(s.quantity);
              for (var p = 0; p < qan; p = p + 1) {
                let cartItem = {
                  primaryKey: itemsInCart.length + 1,
                  _id: m._id,
                  categoryId: m.categoryId,
                  name: m.name,
                  itemType: m.itemType,
                  baseModifierId: m.baseModifierId ? m.baseModifierId : '',
                  sizeKey: s._id,
                  halfIndex: '',
                  isHalf: false,
                  isSecondHalf: false,
                  price: Number(s.price),
                  selectedExtraIngredients: m.selectedExtraIngredients,
                  removedIngredients: m.removedIngredients,
                  orderIndex: m.orderIndex,
                  ...(m.specialId ? { specialId: m.specialId } : {}),
                };
                itemsInCart.push(cartItem);
              }
            }
            return s;
          });
        } else if (m.selectedSizes && m.selectedSizes.length > 0 && m.isHalf) {
          m.selectedSizes.map((s) => {
            if (s.quantity) {
              let qan = Number(s.quantity);
              for (var p = 0; p < qan; p = p + 0.5) {
                let cartItem = {
                  primaryKey: itemsInCart.length + 1,
                  _id: m._id,
                  categoryId: m.categoryId,
                  name: m.name,
                  itemType: m.itemType,
                  baseModifierId: m.baseModifierId ? m.baseModifierId : '',
                  sizeKey: s._id,
                  halfIndex: '',
                  isHalf: true,
                  isSecondHalf: m.isSecondHalf,
                  price: Number(s.price),
                  selectedExtraIngredients: m.selectedExtraIngredients,
                  removedIngredients: m.removedIngredients,
                  orderIndex: m.orderIndex,
                  ...(m.specialId ? { specialId: m.specialId } : {}),
                };
                itemsInCart.push(cartItem);
              }
            }
            return s;
          });
        }
        return m;
      });
    }
    return itemsInCart;
  };

  detectOffers = (currentOd, rowItems) => {
    let rawOfferFrames = this.getOfferFrames();
    let offerFrames = [];
    this.itemsUsedForOfferDetection = [];
    this.itemsUsedForReward = [];
    if (rawOfferFrames.length > 0) {
      let itemsUsed = [];
      rawOfferFrames.map((offerFrame) => {
        if (offerFrame.type === '1') {
          let matchingRowItems = rowItems.filter((rowItem) => {
            return (
              offerFrame.activeCategoryKeys &&
              offerFrame.activeCategoryKeys.includes(rowItem.categoryId) &&
              ((offerFrame.activeSizeKeys &&
                offerFrame.activeSizeKeys.includes(rowItem.sizeKey)) ||
                (offerFrame.activeModifierKeys &&
                  offerFrame.activeModifierKeys.includes(rowItem.sizeKey))) &&
              offerFrame.activeMenuItemKeys &&
              offerFrame.activeMenuItemKeys.includes(rowItem._id) &&
              !itemsUsed.includes(rowItem.primaryKey)
            );
          });
          let count = 0;
          matchingRowItems.map((rowItem) => {
            count = count + (rowItem.isHalf ? 0.5 : 1);
            return rowItem;
          });
          offerFrame.totalOrderCount = offerFrame.orderCount + count;
          offerFrame.matchingRowItems = matchingRowItems;
        } else {
          offerFrame.totalOrderCount = offerFrame.orderCount;
          offerFrame.matchingRowItems = [];
        }
        return offerFrame;
      });
    }
    rawOfferFrames = rawOfferFrames.filter((offer) => {
      return (
        offer.totalOrderCount >=
        (offer.type === '1' ? Number(offer.quantity) : Number(offer.noOfOrders))
      );
    });
    rawOfferFrames.map((offer) => {
      let leftQauntity = Number(offer.orderCount);
      if (offer.type === '1') {
        for (
          let j = 0;
          Number(offer.quantity) * j < offer.totalOrderCount;
          j++
        ) {
          let iNeedQuantityFromCart = 0;
          let obj = { ...offer };
          let numPush =
            Number(offer.quantity) * (j + 1) <= offer.totalOrderCount
              ? Number(offer.quantity)
              : offer.totalOrderCount - Number(offer.quantity) * j;
          if (numPush >= Number(offer.quantity)) {
            if (leftQauntity <= 0) {
              iNeedQuantityFromCart = numPush;
            } else if (leftQauntity < numPush && leftQauntity > 0) {
              iNeedQuantityFromCart = numPush - leftQauntity;
            }
            if (numPush >= leftQauntity) {
              leftQauntity = 0;
            } else {
              leftQauntity = leftQauntity - numPush;
            }
            let useItems = [];
            offer.matchingRowItems.map((p) => {
              if (
                !this.itemsUsedForOfferDetection.includes(p.primaryKey) &&
                !this.itemsUsedForReward.includes(p.primaryKey) &&
                useItems.length < iNeedQuantityFromCart
              ) {
                useItems.push(p);
              }
              return p;
            });
            if (iNeedQuantityFromCart === useItems.length) {
              obj.iNeedQuantityFromCart = iNeedQuantityFromCart;
              obj.itemsUsed = useItems;
              this.itemsUsedForOfferDetection = [
                ...this.itemsUsedForOfferDetection,
                ...useItems.map((p) => p.primaryKey),
              ];
              delete obj.matchingRowItems;
              let rewardFrames = this.getRewardFrame(obj);
              let rewardForOffer = this.detectReward(
                currentOd,
                rowItems,
                rewardFrames
              );
              obj.rewards = rewardForOffer;
              offerFrames.push(obj);
            }
          }
        }
      } else if (Number(offer.noOfOrders) >= 0) {
        for (
          let j = 0;
          (Number(offer.noOfOrders) || 1) * j < offer.totalOrderCount;
          j++
        ) {
          let obj = { ...offer };
          let numPush =
            Number(offer.noOfOrders) * (j + 1) <= offer.totalOrderCount
              ? Number(offer.noOfOrders)
              : offer.totalOrderCount - Number(offer.noOfOrders) * j;
          if (numPush >= Number(offer.noOfOrders)) {
            if (numPush >= leftQauntity) {
              leftQauntity = 0;
            } else {
              leftQauntity = leftQauntity - numPush;
            }
            let rewardFrames = this.getRewardFrame(obj);
            let rewardForOffer = this.detectReward(
              currentOd,
              rowItems,
              rewardFrames
            );
            obj.rewards = rewardForOffer;
            offerFrames.push(obj);
          }
        }
      }
      return offer;
    });
    return offerFrames;
  };

  detectReward = (currentOd, rowItems, rewardFrames) => {
    this.itemsUsed = [];
    this.rewardItemsObj = [];
    let rewards = [];
    if (rowItems && rowItems.length > 0 && rewardFrames.length > 0) {
      rewardFrames = sortBy(rewardFrames, 'slotLength').reverse();
      rewardFrames.map((s) => {
        this.getRewardDetectionCount(s, rowItems);
        return s;
      });
      let detectedRewards = this.rewardItemsObj;
      if (detectedRewards && detectedRewards.length > 0) {
        detectedRewards.map((sd) => {
          let itemsToBeAddedInOffer = [];
          sd.slots.map((ss) => {
            let rowMenuItems = JSON.parse(JSON.stringify(currentOd.menuItems));
            let filteredItem = [];
            filteredItem = rowMenuItems.filter((ff) => {
              return ff._id === ss.itemId && ss.orderIndex === ff.orderIndex;
            });
            if (filteredItem && filteredItem.length > 0) {
              filteredItem.map((ftmm) => {
                let ttml = ftmm;
                if (this.detectMergeRequired(ss, ttml)) {
                  ttml.selectedSizes = ttml.selectedSizes.filter((ggm) => {
                    return ss.sizeKeyMatched === ggm._id;
                  });
                  if (ttml.selectedSizes && ttml.selectedSizes.length > 0) {
                    ttml.selectedSizes[0].quantity = ttml.isHalf ? 0.5 : 1;
                    if (ttml.isHalf) {
                      itemsToBeAddedInOffer.push(ttml);
                      const otherHalf = ttml.whichHalf === 1 ? 2 : 1;
                      let othersHalf = rowMenuItems.filter((m) => {
                        return (
                          m.halfIndex === ttml.halfIndex &&
                          m.whichHalf === otherHalf
                        );
                      });
                      if (othersHalf.length > 0) {
                        let ttmll = othersHalf[0];
                        ttmll.selectedSizes[0].quantity = 0.5;
                        ttml = { ...ttmll };
                      }
                    }
                    itemsToBeAddedInOffer.push(ttml);
                  }
                }
                return ftmm;
              });
            }
            return ss;
          });
          let matchingOffer = this.props.offers.filter((obj) => {
            return obj._id === sd._id;
          });
          if (
            itemsToBeAddedInOffer &&
            itemsToBeAddedInOffer.length > 0 &&
            matchingOffer.length > 0
          ) {
            let matchedOffer = matchingOffer[0];
            let discountedPrice = 0;
            if (sd.isAnyOneItemAvailable) {
              matchedOffer.rewardItems.forEach((obj) => {
                if (
                  discountedPrice !== 0 &&
                  discountedPrice > Number(obj.discountedPrice)
                )
                  discountedPrice = Number(obj.discountedPrice);
                else discountedPrice = Number(obj.discountedPrice);
              });
            } else {
              discountedPrice = matchedOffer.rewardItems.reduce(
                (total, obj) => {
                  return (total = total + Number(obj.discountedPrice));
                },
                0
              );
            }
            let totalCost = 0,
              offerDiscount = 0;
            itemsToBeAddedInOffer.map((m) => {
              let itemPrice = this.getItemPrice(m, true);
              if (sd.isAnyOneItemAvailable) {
                if (totalCost !== 0 && totalCost < Number(itemPrice))
                  totalCost = Number(itemPrice);
                else if (totalCost === 0) totalCost = Number(itemPrice);
              } else totalCost = totalCost + Number(itemPrice);
              return m;
            });
            offerDiscount = totalCost - Number(discountedPrice);
            let sObj = {
              _id: matchedOffer._id,
              name: matchedOffer.name,
              discount: offerDiscount.toFixed(2),
              slots: sd.slots,
              isComplete: sd.isComplete,
            };
            rewards.push(sObj);
          }
          return sd;
        });
      }
    }
    return rewards;
  };

  detectSpecial = (currentOd, rowItems) => {
    this.itemsUsed = [];
    this.specialItemsObj = [];
    let specialObj = { specials: [] };
    let specialFrames = this.getSpecialFrames(currentOd);
    if (rowItems && rowItems.length > 0 && specialFrames.length > 0) {
      specialFrames = sortBy(specialFrames, 'slotLength').reverse();
      specialFrames = specialFrames.map((s) => {
        this.getSpecialDetectionCount(s, rowItems, 0);
        return s;
      });
      let detectedSpecials = this.specialItemsObj;
      if (detectedSpecials && detectedSpecials.length > 0) {
        detectedSpecials.map((sd) => {
          let itemsToBeAddedInSpecials = [];
          let finalSpecial = sd;
          finalSpecial.slots.map((ss) => {
            let rowMenuItems = JSON.parse(JSON.stringify(currentOd.menuItems));
            let filteredItem = [];
            if (ss.isHalf) {
              filteredItem = rowMenuItems.filter((ff) => {
                return this.props.home?.orderSetup?.isSpecialsManuallyDisabled
                  ? ff.specialId &&
                      ff._id === ss.itemId &&
                      ff.isSecondHalf === false &&
                      ff.orderIndex === ss.orderIndex
                  : ff._id === ss.itemId &&
                      ff.isSecondHalf === false &&
                      ff.orderIndex === ss.orderIndex;
              });
            } else {
              filteredItem = rowMenuItems.filter((ff) => {
                return this.props.home?.orderSetup?.isSpecialsManuallyDisabled
                  ? ff.specialId &&
                      ff._id === ss.itemId &&
                      ff.orderIndex === ss.orderIndex
                  : ff._id === ss.itemId && ff.orderIndex === ss.orderIndex;
              });
            }
            if (filteredItem && filteredItem.length > 0) {
              filteredItem.map((ftmm) => {
                let ttml = ftmm;
                ttml.selectedSizes = ttml.selectedSizes.filter((ggm) => {
                  return ss.sizeKeyMatched === ggm._id;
                });
                if (ttml.selectedSizes && ttml.selectedSizes.length > 0) {
                  ttml.selectedSizes[0].quantity = ttml.isHalf ? 0.5 : 1;
                  if (ttml.isHalf) {
                    let othersHalf = rowMenuItems.filter((m) => {
                      return (
                        m.halfIndex === ttml.halfIndex &&
                        m.isSecondHalf === true
                      );
                    });
                    if (othersHalf.length > 0) {
                      let ttmll = othersHalf[0];
                      ttml.urlHalf = ttmll.urlS3;
                      ttml._idHalf = ttmll._id;
                      ttml.nameHalf = ttmll.name;
                      ttml.selectedSizesHalf = ttmll.selectedSizes;
                      ttml.selectedIngredientsHalf = ttmll.selectedIngredients;
                      ttml.removedIngredientsHalf = ttmll.removedIngredients;
                      ttml.selectedExtraIngredientsHalf =
                        ttmll.selectedExtraIngredients;
                      ttml.selectedSizesHalf = ttmll.selectedSizes.filter(
                        (ggm) => {
                          return (
                            ss.sizeKeys.indexOf(ggm._id) >= 0 ||
                            ss.modifierKeys.indexOf(ggm._id) >= 0
                          );
                        }
                      );
                      if (ttml.selectedSizesHalf.length > 0)
                        ttml.selectedSizesHalf[0].quantity = 0.5;
                    }
                  }
                  ttml.isFreeItem = ss.isFreeItem;
                  ttml.discountedPrice = ss.discountedPrice;
                  itemsToBeAddedInSpecials.push(ttml);
                }
                return ftmm;
              });
            }
            rowItems.map((rI) => {
              if (rI.primaryKey === ss.primaryKey) {
                rI.specialId = sd._id;
                rI.itemsUsedInSepcials = true;
              }
              return rI;
            });
            return ss;
          });
          let specialItems =
            this.props.home && this.props.home.allSpecials
              ? this.props.home.allSpecials.filter((obj) => {
                  return obj._id === sd._id;
                })
              : [];
          if (
            itemsToBeAddedInSpecials &&
            itemsToBeAddedInSpecials.length > 0 &&
            specialItems.length > 0
          ) {
            let specialItem = specialItems[0];
            let totalCost = 0,
              specialDiscount = 0,
              upsalePrice = 0;
            itemsToBeAddedInSpecials.map((m) => {
              let itemPrice = this.getItemPriceForSpecialDiscount(m);
              let upsale = this.getUpsalePrice(m, specialItem);
              upsalePrice = upsalePrice + upsale;
              if (specialItem.type !== '1') {
                if (m.isFreeItem === true && m.discountedPrice === '0')
                  specialDiscount = specialDiscount + Number(itemPrice);
                else if (m.isFreeItem === true && m.discountedPrice !== '0')
                  specialDiscount =
                    specialDiscount +
                    (Number(itemPrice) - Number(m.discountedPrice));
              }
              totalCost = totalCost + Number(itemPrice);
              return m;
            });

            if (specialItem.type === '1' && totalCost >= specialItem.cost)
              specialDiscount = totalCost - Number(specialItem.cost);
            let sObj = {
              _id: specialItem._id,
              name: specialItem.name,
              discount: specialDiscount.toFixed(2),
              cost: specialItem.cost,
              type: specialItem.type,
              upsalePrice: upsalePrice.toFixed(2),
            };
            specialObj.specials.push(sObj);
          }
          return sd;
        });
      }
    }
    specialObj.rowItems = rowItems;
    return specialObj;
  };

  getUpsalePrice = (menuItem, specialItem) => {
    let upsalePrice = 0;
    if (
      specialItem.selectedCategories &&
      specialItem.selectedCategories.length > 0
    ) {
      specialItem.selectedCategories.map((m) => {
        if (m.menuItems && m.menuItems.length > 0) {
          let matchedItems = m.menuItems.filter((f) => {
            return (
              f._id === menuItem._id &&
              f.categoryId === menuItem.categoryId &&
              f.isActive === true
            );
          });
          if (matchedItems.length > 0 && matchedItems[0].price)
            upsalePrice = Number(matchedItems[0].price);
        }
        return m;
      });
    }
    return upsalePrice;
  };

  detectPersonalizedSpecial = (
    currentOd,
    voucher,
    rowItems,
    filterOutUsedItems
  ) => {
    this.itemsUsed = [];
    this.specialItemsObj = [];
    let specialFrames = this.getPersonalizedSpecialFrames(currentOd, voucher);
    if (filterOutUsedItems) {
      rowItems = rowItems.filter((s) => {
        return !s.itemsUsedInSepcials;
      });
    }

    let voucherDiscountObj = { voucherDiscount: 0, usedIndexes: [] };

    if (rowItems && rowItems.length > 0 && specialFrames.length > 0) {
      this.getSpecialDetectionCount(specialFrames[0], rowItems, 0);
      let detectedSpecials = this.specialItemsObj;
      if (detectedSpecials && detectedSpecials.length > 0) {
        let finalSpecial = detectedSpecials[0];
        let itemsToBeAddedInSpecials = [];
        finalSpecial.slots.map((ss) => {
          let rowMenuItems = JSON.parse(JSON.stringify(currentOd.menuItems));
          let filteredItem = [];
          if (ss.isHalf) {
            filteredItem = rowMenuItems.filter((ff) => {
              return (
                ff._id === ss.itemId &&
                ff.isSecondHalf === false &&
                ff.orderIndex === ss.orderIndex
              );
            });
          } else {
            filteredItem = rowMenuItems.filter((ff) => {
              return ff._id === ss.itemId && ff.orderIndex === ss.orderIndex;
            });
          }
          if (filteredItem && filteredItem.length > 0) {
            filteredItem.map((ftmm) => {
              let ttml = ftmm;
              if (this.detectMergeRequired(ss, ttml)) {
                ttml.selectedSizes = ttml.selectedSizes.filter((ggm) => {
                  return ss.sizeKeyMatched === ggm._id;
                });
                if (ttml.selectedSizes && ttml.selectedSizes.length > 0) {
                  ttml.selectedSizes[0].quantity = ttml.isHalf ? 0.5 : 1;
                  if (ttml.isHalf) {
                    let othersHalf = rowMenuItems.filter((m) => {
                      return (
                        m.halfIndex === ttml.halfIndex &&
                        m.isSecondHalf === true
                      );
                    });
                    if (othersHalf.length > 0) {
                      let ttmll = othersHalf[0];
                      ttml.urlHalf = ttmll.urlS3;
                      ttml._idHalf = ttmll._id;
                      ttml.nameHalf = ttmll.name;
                      ttml.selectedSizesHalf = ttmll.selectedSizes;
                      ttml.selectedIngredientsHalf = ttmll.selectedIngredients;
                      ttml.removedIngredientsHalf = ttmll.removedIngredients;
                      ttml.selectedExtraIngredientsHalf =
                        ttmll.selectedExtraIngredients;
                      ttml.selectedSizesHalf = ttmll.selectedSizes.filter(
                        (ggm) => {
                          return (
                            ss.sizeKeys.indexOf(ggm._id) >= 0 ||
                            ss.modifierKeys.indexOf(ggm._id) >= 0
                          );
                        }
                      );
                      ttml.selectedSizesHalf[0].quantity = 0.5;
                    }
                  }
                  itemsToBeAddedInSpecials.push(ttml);
                }
              }
              return ftmm;
            });
          }
          voucherDiscountObj.usedIndexes.push(ss.primaryKey);
          return ss;
        });
        if (itemsToBeAddedInSpecials && itemsToBeAddedInSpecials.length > 0) {
          let totalCost = 0;
          let discountedItemsPrice = 0;
          itemsToBeAddedInSpecials.map((m) => {
            let itemPrice = this.getItemPrice(m);
            totalCost = totalCost + Number(itemPrice);
            if (discountedItemsPrice > 0) {
              discountedItemsPrice += itemPrice;
            } else {
              const oneItemPrice = itemPrice / (m?.quantity || 1);
              discountedItemsPrice +=
                itemPrice - oneItemPrice + Number(voucher.discountedPrice);
            }
            return m;
          });

          voucherDiscountObj.voucherDiscount = totalCost - discountedItemsPrice;
        }
      }
      if (voucherDiscountObj.voucherDiscount <= 0) {
        let totalCost = 0;
        let discountedItemsPrice = 0;
        const { menuItems, menuSizes } = voucher?.selectedCategories[0];
        currentOd?.menuItems?.forEach((mI) => {
          const { _id, selectedSizes, quantity } = mI;
          const isMenuItemEligibleForVoucher =
            Boolean(
              menuItems?.find(
                (vMenuItem) => vMenuItem?.isActive && vMenuItem?._id === _id
              )
            ) &&
            Boolean(
              menuSizes?.find(
                (vMenuSize) =>
                  vMenuSize?.isActive &&
                  vMenuSize?._id === selectedSizes[0]?._id
              )
            ) &&
            rowItems.find((rI) => rI?._id === _id);

          if (isMenuItemEligibleForVoucher) {
            const itemPrice = Number(this.getItemPrice(mI));
            totalCost += itemPrice;
            if (discountedItemsPrice > 0) {
              discountedItemsPrice += itemPrice;
            } else {
              const oneItemPrice = itemPrice / quantity;
              discountedItemsPrice +=
                itemPrice - oneItemPrice + Number(voucher.discountedPrice);
            }
          }
        });

        voucherDiscountObj.voucherDiscount = totalCost - discountedItemsPrice;
      }
    }
    return voucherDiscountObj;
  };

  getRewardDetectionCount = (frame, rowItems) => {
    let ct = 0;
    let s = JSON.parse(JSON.stringify(frame));
    let itemsUsedForS = [];
    if (s.slots && s.slots.length > 0) {
      s.slots = s.slots.map((i) => {
        let itemExistForMatch = rowItems.filter((r) => {
          return (
            i.categoryKeys.indexOf(r.categoryId) >= 0 &&
            (i.sizeKeys.indexOf(r.sizeKey) >= 0 ||
              i.modifierKeys.indexOf(r.sizeKey) >= 0) &&
            i.menuItems.indexOf(r._id) < 0
          );
        });
        if (itemExistForMatch.length > 0) {
          for (let l = 0; l < itemExistForMatch.length; l++) {
            if (
              !includes(itemsUsedForS, itemExistForMatch[l].primaryKey) &&
              !includes(
                this.itemsUsedForReward,
                itemExistForMatch[l].primaryKey
              ) &&
              !includes(
                this.itemsUsedForOfferDetection,
                itemExistForMatch[l].primaryKey
              ) &&
              !i.isSlotOccupied
            ) {
              i.isSlotOccupied = true;
              i.itemId = itemExistForMatch[l]._id;
              i.primaryKey = itemExistForMatch[l].primaryKey;
              i.orderIndex = itemExistForMatch[l].orderIndex;
              i.name = itemExistForMatch[l].name;
              i.isHalf = itemExistForMatch[l].isHalf;
              i.isSecondHalf = itemExistForMatch[l].isSecondHalf;
              i.removedIngredients = itemExistForMatch[l].removedIngredients;
              i.selectedExtraIngredients =
                itemExistForMatch[l].selectedExtraIngredients;
              i.sizeKeyMatched = itemExistForMatch[l].sizeKey;
              itemsUsedForS.push(itemExistForMatch[l].primaryKey);
              ct = ct + 1;
            }
          }
        }
        return i;
      });
      this.itemsUsedForReward = [...this.itemsUsedForReward, ...itemsUsedForS];
      this.rewardItemsObj.push({
        _id: s._id,
        name: s.name,
        slots: s.slots,
        isAnyOneItemAvailable: s.isAnyOneItemAvailable,
        isComplete: ct === s.slots.length ? true : false,
      });
    }
  };

  getSpecialDetectionCount = (frame, rowItems, specialCount) => {
    let ct = 0;
    let s = JSON.parse(JSON.stringify(frame));
    let itemsUsedForS = [];
    if (s.slots && s.slots.length > 0) {
      s.slots = s.slots.map((i) => {
        let itemExistForMatch = rowItems.filter((r) => {
          return this.props.home?.orderSetup?.isSpecialsManuallyDisabled
            ? r.specialId &&
                i.categoryKeys.indexOf(r.categoryId) >= 0 &&
                (i.sizeKeys.indexOf(r.sizeKey) >= 0 ||
                  i.modifierKeys.indexOf(r.sizeKey) >= 0) &&
                i.menuItems.indexOf(r._id) < 0
            : i.categoryKeys.indexOf(r.categoryId) >= 0 &&
                (i.sizeKeys.indexOf(r.sizeKey) >= 0 ||
                  i.modifierKeys.indexOf(r.sizeKey) >= 0) &&
                i.menuItems.indexOf(r._id) < 0;
        });
        if (itemExistForMatch.length > 0) {
          for (let l = 0; l < itemExistForMatch.length; l++) {
            if (
              !includes(itemsUsedForS, itemExistForMatch[l].primaryKey) &&
              !includes(this.itemsUsed, itemExistForMatch[l].primaryKey) &&
              !i.isSlotOccupied
            ) {
              i.isSlotOccupied = true;
              i.itemId = itemExistForMatch[l]._id;
              i.primaryKey = itemExistForMatch[l].primaryKey;
              i.orderIndex = itemExistForMatch[l].orderIndex;
              i.name = itemExistForMatch[l].name;
              i.isHalf = itemExistForMatch[l].isHalf;
              i.isSecondHalf = itemExistForMatch[l].isSecondHalf;
              i.removedIngredients = itemExistForMatch[l].removedIngredients;
              i.selectedExtraIngredients =
                itemExistForMatch[l].selectedExtraIngredients;
              i.sizeKeyMatched = itemExistForMatch[l].sizeKey;
              itemsUsedForS.push(itemExistForMatch[l].primaryKey);
              ct = ct + 1;
            }
          }
        }
        return i;
      });
      if (ct === s.slots.length) {
        s.isComplete = true;
        this.itemsUsed = [...this.itemsUsed, ...itemsUsedForS];
        this.specialItemsObj.push({
          _id: s._id,
          name: s.name,
          slots: s.slots,
        });
        if (s.slots.length <= rowItems.length - this.itemsUsed.length)
          this.getSpecialDetectionCount(frame, rowItems, specialCount + 1);
      }
    }
  };

  removeOutOfScheduleItems = () => {
    let { menuItemSchedules, currentOrder, setState } = this.props;
    let ctOrder = JSON.parse(JSON.stringify(currentOrder));
    let menuItems = [];
    let halfItems = [];
    menuItems = ctOrder?.menuItems?.filter(({ _id, isHalf, halfIndex }) => {
      return !menuItemSchedules.some(({ menuItemId, isAvailableNow }) => {
        if (isHalf && menuItemId === _id && !isAvailableNow) {
          halfItems.push({ halfIndex });
        }
        return menuItemId === _id && !isAvailableNow && !isHalf;
      });
    });

    ctOrder.menuItems = menuItems;

    if (halfItems.length > 0) {
      let items = [];
      ctOrder.menuItems.forEach((p) => {
        let matchingHalfIndexs = halfItems.filter((h) => {
          return h.halfIndex === p.halfIndex;
        });
        if (matchingHalfIndexs.length <= 0) items.push(p);
      });
      ctOrder.menuItems = items;
    }

    const updatedCurrentOrder = this.getOrderCalculations(ctOrder);
    setState({ currentOrder: updatedCurrentOrder });
  };

  removeSoldOutItems = () => {
    const { setState, currentOrder } = this.props;
    let ctOrder = JSON.parse(JSON.stringify(currentOrder));
    let halfItems = [];
    let halfSizes = [];
    ctOrder.menuItems.map((item) => {
      if (
        item.selectedSizes.every(
          (s) => s.isAvailable && s.variants.every((v) => v.availability)
        )
      ) {
        if (item.selectedSizes) {
          let matchedSize = item.selectedSizes[0];
          if (!matchedSize.isAvailable) item.selectedSizes[0].isDelete = true;
          else {
            let cnt = 0;
            if (matchedSize.variants) {
              matchedSize.variants.map((sv) => {
                let matchingVs = matchedSize.variants
                  ? matchedSize.variants.filter(
                      (f) => f._id === sv._id && f.isAvailable
                    )
                  : [];
                if (matchingVs.length <= 0) cnt = cnt + 1;
                return sv;
              });
            }
            if (cnt !== 0) matchedSize.isDelete = true;
            else matchedSize.isDelete = false;
          }
        }
        item.isDelete = false;
      } else {
        item.isDelete = true;
        if (item.isHalf) {
          halfItems.push({
            halfIndex: item.halfIndex,
            itemId: item._id,
            isItem: true,
          });
        }
      }
      return item;
    });
    let menuItems = [];
    ctOrder.menuItems.forEach((p) => {
      if (!p.isDelete) {
        p.selectedSizes = p.selectedSizes.filter((s) => {
          return !s.isDelete;
        });
        if (p.selectedSizes.length > 0) {
          menuItems.push(p);
        }
      }
    });
    ctOrder.menuItems = menuItems;
    if (halfItems.length > 0) {
      let items = [];
      ctOrder.menuItems.forEach((p) => {
        let matchingHalfIndexs = halfItems.filter((h) => {
          return h.halfIndex === p.halfIndex;
        });
        if (matchingHalfIndexs.length < 0) items.push(p);
      });
      ctOrder.menuItems = items;
    }
    if (halfSizes.length > 0) {
      let items = [];
      ctOrder.menuItems.map((p) => {
        if (p.isHalf) {
          let sizes = [];
          p.selectedSizes.forEach((s) => {
            let count = 0;
            halfSizes.forEach((h) => {
              if (h.halfIndex === p.halfIndex && h.sizeId === s._id)
                count = count + 1;
            });
            if (count === 0) sizes.push(s);
          });
          p.selectedSizes = sizes;
          if (p.selectedSizes.length > 0) items.push(p);
        } else {
          items.push(p);
        }
        return p;
      });
      ctOrder.menuItems = items;
    }
    const updatedCurrentOrder = this.getOrderCalculations(ctOrder);
    setState({ currentOrder: updatedCurrentOrder });
  };

  getDiscountedAmount = (
    selectedVoucher,
    currentOrder = this.props.currentOrder,
    rowItems = this.getItemsInCart(currentOrder),
    specialDiscount = currentOrder.specialDiscount,
    payableAmount = currentOrder.payableAmount
  ) => {
    let resObj = {
      discount: 0,
      isVoucherValid: false,
      isItemOccupiedWithSpecials: false,
    };
    if (
      currentOrder &&
      selectedVoucher &&
      (selectedVoucher.type === '2' || selectedVoucher.type === '1')
    ) {
      resObj.isVoucherValid = true;
      if (selectedVoucher.voucherType === '1') {
        resObj.discount = (
          (Number(payableAmount) * Number(selectedVoucher.discount)) /
          100
        ).toFixed(2);
        return resObj;
      } else {
        resObj.discount = selectedVoucher.discount;
        return resObj;
      }
    } else if (
      currentOrder &&
      selectedVoucher &&
      selectedVoucher.type === '3'
    ) {
      let discountWithoutFlag = this.detectPersonalizedSpecial(
        currentOrder,
        selectedVoucher,
        rowItems,
        false
      );
      if (!selectedVoucher.isAvailableWithSpecials) {
        let discountFlag = this.detectPersonalizedSpecial(
          currentOrder,
          selectedVoucher,
          rowItems,
          true
        );
        if (
          discountWithoutFlag.voucherDiscount !== 0 &&
          discountFlag.voucherDiscount === 0
        ) {
          rowItems = sortBy(
            rowItems.filter((f) => {
              return !discountWithoutFlag.usedIndexes.includes(f.primaryKey);
            }),
            'price'
          ).reverse();

          let specialObj = this.detectSpecial(currentOrder, rowItems);

          let specials = specialObj.specials;
          //Calculate speical's discount
          let discount = 0;
          specials.map((s) => {
            discount = discount + Number(s.discount);
            return s;
          });
          if (
            Number(specialDiscount) - discount >
            discountWithoutFlag.voucherDiscount
          ) {
            resObj.isItemOccupiedWithSpecials = false;
            resObj.isVoucherValid = false;
            resObj.discount = discountFlag.voucherDiscount;
          } else {
            resObj.isItemOccupiedWithSpecials = true;
            resObj.isVoucherValid = true;
            resObj.specials = specials;
            resObj.discount = discountWithoutFlag.voucherDiscount;
          }
        } else {
          resObj.discount = discountFlag.voucherDiscount;
          resObj.isVoucherValid = true;
        }
      } else {
        resObj.isVoucherValid = true;
        resObj.discount = discountWithoutFlag.voucherDiscount;
      }
      return resObj;
    } else return resObj;
  };

  getItemPrice = (itemObj, isLoyalty) => {
    const { halfHalfSetup } = this.props;
    let itemPrice = 0;
    let quantity = 0;
    let extraPrice = 0;
    let currentItem = JSON.parse(JSON.stringify(itemObj));
    if (!currentItem.itemType || currentItem.itemType === 0) {
      currentItem?.selectedSizes?.map((item) => {
        if (item.quantity > 0) {
          quantity = quantity + item.quantity;
          itemPrice = itemPrice + item.quantity * Number(item.price);
        }
        if (item.variants && !isLoyalty) {
          item.variants.map((v) => {
            if (v.quantity && Number(v.quantity) > 0)
              itemPrice = itemPrice + item.quantity * Number(v.price);
            return v;
          });
        }
        return item;
      });
      if (quantity > 0 && !isLoyalty) {
        currentItem?.selectedExtraIngredients?.map((item) => {
          if (item.quantity > 0) {
            extraPrice =
              extraPrice + Number(item.quantity) * Number(item.price);
          }
          return item;
        });
        itemPrice =
          extraPrice *
            (halfHalfSetup?.chargeFullHalfExtraPrice
              ? Math.max(quantity, 1)
              : quantity) +
          itemPrice;
        if (itemObj.isHalf) {
          itemPrice =
            itemPrice +
            (this.props?.halfHalfSetup?.halfHalfAdditionalCharges
              ? Number(this.props.halfHalfSetup.halfHalfAdditionalCharges)
              : 0) *
              quantity;
        }
      }
    } else {
      currentItem?.selectedModifiers?.forEach((m) => {
        m.subModifiers.forEach((s) => {
          if (m._id === currentItem.baseModifierId) {
            quantity = s.quantity;
            itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
            if (s.variants && !isLoyalty) {
              s.variants.forEach((v) => {
                itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
              });
            }
          } else {
            if (s.prices && !isLoyalty) {
              s.prices.forEach((p) => {
                itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                if (p.variants) {
                  p.variants.forEach((v) => {
                    itemPrice =
                      itemPrice + Number(v.quantity) * Number(v.price);
                  });
                }
              });
            }
          }
        });
      });
      if (quantity > 0 && !isLoyalty) {
        currentItem?.selectedExtraIngredients?.map((item) => {
          if (item.quantity > 0) {
            extraPrice =
              extraPrice + Number(item.quantity) * Number(item.price);
          }
          return item;
        });
        itemPrice =
          extraPrice *
            (halfHalfSetup?.chargeFullHalfExtraPrice
              ? Math.max(quantity, 1)
              : quantity) +
          itemPrice;
        if (itemObj.isHalf) {
          itemPrice =
            itemPrice +
            (this.props?.halfHalfSetup?.halfHalfAdditionalCharges
              ? Number(this.props.halfHalfSetup.halfHalfAdditionalCharges)
              : 0) *
              quantity;
        }
      }
    }
    return itemPrice.toFixed(2);
  };

  getItemPriceForSpecialDiscount = (itemObj) => {
    let itemPrice = 0;
    let currentItem = JSON.parse(JSON.stringify(itemObj));
    // if (!currentItem.itemType || currentItem.itemType === 0) {
    currentItem.selectedSizes &&
      currentItem.selectedSizes.map((item) => {
        if (Number(item.quantity) > 0) {
          itemPrice = itemPrice + Number(item.quantity) * Number(item.price);
        }
        return item;
      });
    if (itemObj.isHalf) {
      currentItem.selectedSizesHalf &&
        currentItem.selectedSizesHalf.map((item) => {
          if (Number(item.quantity) > 0) {
            itemPrice = itemPrice + item.quantity * item.price;
          }
          return item;
        });
    }
    return itemPrice.toFixed(2);
  };

  showSpecialsHandler = (arrObj) => {
    this.setState((prevState) => {
      return {
        arrKey: arrObj._id,
        rightSideViewVisibilityIndex: 3,
        toggleSpecials:
          prevState.arrKey === arrObj._id
            ? this.state.toggleSpecials
            : !this.state.toggleSpecials,
        specialItem: arrObj,
        selectedSpecials: [],
      };
    });
  };

  getOfferFrames = () => {
    let rawOfferFrames = [];
    if (this.props.offers && this.props.home.pathwayToOffers) {
      rawOfferFrames = this.props.offers.map((offer) => {
        let matchingProgress = this.props.home.pathwayToOffers.filter(
          (path) => {
            return path.offerId === offer._id;
          }
        );
        if (matchingProgress.length > 0) {
          let count = matchingProgress.reduce((total, item) => {
            return total + item.orderCount;
          }, 0);
          offer.orderCount = count;
        } else {
          offer.orderCount = 0;
        }
        return offer;
      });
    }
    return rawOfferFrames;
  };

  getRewardFrame = (offer) => {
    let rewardFrames = [];
    let x = {
      _id: offer._id,
      name: offer.name,
      isComplete: false,
      slots: [],
      isAnyOneItemAvailable: offer.isAnyOneItemAvailable,
    };
    offer.rewardItems &&
      offer.rewardItems.map((sp) => {
        new Array(Number(sp.quantity)).fill().map((_m, i) => {
          let u = {
            categoryKeys: sp.categories
              .filter((s) => {
                return s.isActive;
              })
              .map((s) => s._id),
            sizeKeys: sp.sizes
              ? sp.sizes
                  .filter((s) => {
                    return s.isActive;
                  })
                  .map((s) => s._id)
              : [],
            modifierKeys: sp.subModifiers
              ? sp.subModifiers
                  .filter((s) => {
                    return s.isActive;
                  })
                  .map((s) => s._id)
              : [],
            menuItems: sp.menuItems
              .filter((s) => {
                return !s.isActive;
              })
              .map((s) => s._id),
            id: i + 1,
            isSlotOccupied: false,
          };
          x.slots.push(u);
          return _m;
        });
        return sp;
      });
    x.slotLength = x.slots.length;
    rewardFrames.push(x);
    return rewardFrames;
  };

  getSpecialFrames = (currentOd) => {
    const { storeConfig } = this.props;
    let specialFrames = [];
    if (this.props.home.allSpecials && this.props.home.allSpecials.length > 0) {
      let specials = this.props.home.allSpecials.filter(
        (f) =>
          f.orderFromKeys.includes('1') &&
          f.orderTypeKeys.includes(currentOd.orderType) &&
          f.isPublished
      );
      specials.map((s) => {
        if (currentOd.deliveryDate) {
          if (
            s.hasOwnProperty(
              getDayFlag(currentOd.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
            ) &&
            s[
              getDayFlag(currentOd.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
            ] === true &&
            this.isSpecialAvaiableAllDay(
              s,
              currentOd.deliveryDate,
              storeConfig.timeZone
            ) &&
            this.isSpecialAvaiableOnPublicHoliday(
              s,
              currentOd.deliveryDate,
              storeConfig.timeZone
            )
          ) {
            let x = {
              _id: s._id,
              name: s.name,
              type: s.type,
              isAvailablePickup: s.isAvailablePickup,
              isAvailableDelivery: s.isAvailableDelivery,
              isComplete: false,
              slots: [],
            };
            s.selectedCategories &&
              s.selectedCategories.map((sp) => {
                new Array(Number(sp.quantity)).fill().map((_m, i) => {
                  let u = {
                    categoryKeys: sp.categories
                      .filter((s) => {
                        return s.isActive;
                      })
                      .map((s) => s._id),
                    sizeKeys: sp.menuSizes
                      ? sp.menuSizes
                          .filter((s) => {
                            return s.isActive;
                          })
                          .map((s) => s._id)
                      : [],
                    modifierKeys: sp.subModifiers
                      ? sp.subModifiers
                          .filter((s) => {
                            return s.isActive;
                          })
                          .map((s) => s._id)
                      : [],
                    menuItems: sp.menuItems
                      .filter((s) => {
                        return !s.isActive;
                      })
                      .map((s) => s._id),
                    id: i + 1,
                    index: sp.isFreeItem ? i + 1 : -50,
                    isSlotOccupied: false,
                    isFreeItem: sp.isFreeItem,
                    discountedPrice: sp.discountedPrice
                      ? sp.discountedPrice
                      : '0',
                  };
                  x.slots.push(u);
                  return _m;
                });
                return sp;
              });
            x.slotLength = x.slots.length;
            specialFrames.push(x);
          }
        } else {
          if (
            s.hasOwnProperty(getCurrentDayFlag(storeConfig.timeZone).dayText) &&
            s[getCurrentDayFlag(storeConfig.timeZone).dayText] === true &&
            this.isSpecialAvaiableAllDay(s, undefined, storeConfig.timeZone) &&
            this.isSpecialAvaiableOnPublicHoliday(
              s,
              undefined,
              storeConfig.timeZone
            )
          ) {
            let x = {
              _id: s._id,
              name: s.name,
              type: s.type,
              isAvailablePickup: s.isAvailablePickup,
              isAvailableDelivery: s.isAvailableDelivery,
              isComplete: false,
              slots: [],
            };
            s.selectedCategories &&
              s.selectedCategories.map((sp) => {
                new Array(Number(sp.quantity)).fill().map((_m, i) => {
                  let u = {
                    categoryKeys: sp.categories
                      .filter((s) => {
                        return s.isActive;
                      })
                      .map((s) => s._id),
                    sizeKeys: sp.menuSizes
                      ? sp.menuSizes
                          .filter((s) => {
                            return s.isActive;
                          })
                          .map((s) => s._id)
                      : [],
                    modifierKeys: sp.subModifiers
                      ? sp.subModifiers
                          .filter((s) => {
                            return s.isActive;
                          })
                          .map((s) => s._id)
                      : [],
                    menuItems: sp.menuItems
                      .filter((s) => {
                        return !s.isActive;
                      })
                      .map((s) => s._id),
                    id: i + 1,
                    index: sp.isFreeItem ? i + 1 : -50,
                    isSlotOccupied: false,
                    isFreeItem: sp.isFreeItem,
                    discountedPrice: sp.discountedPrice
                      ? sp.discountedPrice
                      : '0',
                  };
                  x.slots.push(u);
                  return _m;
                });
                return sp;
              });
            x.slotLength = x.slots.length;
            specialFrames.push(x);
          }
        }
        return s;
      });
    }
    return specialFrames;
  };

  getPersonalizedSpecialFrames = (currentOd, voucher) => {
    const { storeConfig } = this.props;
    let specialFrames = [];
    if (
      (currentOd.orderType === '1' && voucher.isAvailablePickup) ||
      (currentOd.orderType === '2' && voucher.isAvailableDelivery) ||
      (currentOd.orderType === '3' && voucher.isAvailableDineIn)
    ) {
      if (currentOd.deliveryDate) {
        if (
          voucher.hasOwnProperty(
            getDayFlag(currentOd.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
          ) &&
          voucher[
            getDayFlag(currentOd.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
          ] === true
        ) {
          let x = {
            _id: voucher._id,
            name: voucher.voucherCode,
            type: voucher.type,
            isAvailablePickup: voucher.isAvailablePickup,
            isAvailableDelivery: voucher.isAvailableDelivery,
            isComplete: false,
            slots: [],
          };
          voucher.selectedCategories &&
            voucher.selectedCategories.map((sp) => {
              new Array(Number(sp.quantity)).fill().map((_m, i) => {
                let u = {
                  categoryKeys: sp.categories
                    .filter((s) => {
                      return s.isActive;
                    })
                    .map((s) => s._id),
                  sizeKeys: sp.menuSizes
                    ? sp.menuSizes
                        .filter((s) => {
                          return s.isActive;
                        })
                        .map((s) => s._id)
                    : [],
                  modifierKeys: sp.subModifiers
                    ? sp.subModifiers
                        .filter((s) => {
                          return s.isActive;
                        })
                        .map((s) => s._id)
                    : [],
                  menuItems: sp.menuItems
                    .filter((s) => {
                      return !s.isActive;
                    })
                    .map((s) => s._id),
                  id: i + 1,
                  isSlotOccupied: false,
                };
                x.slots.push(u);
                return _m;
              });
              return sp;
            });
          x.slotLength = x.slots.length;
          specialFrames.push(x);
        }
      } else {
        if (
          voucher.hasOwnProperty(
            getCurrentDayFlag(storeConfig.timeZone).dayText
          ) &&
          voucher[getCurrentDayFlag(storeConfig.timeZone).dayText] === true
        ) {
          let x = {
            _id: voucher._id,
            name: voucher.voucherCode,
            type: voucher.type,
            isAvailablePickup: voucher.isAvailablePickup,
            isAvailableDelivery: voucher.isAvailableDelivery,
            isComplete: false,
            slots: [],
          };
          voucher.selectedCategories &&
            voucher.selectedCategories.map((sp) => {
              new Array(Number(sp.quantity)).fill().map((_m, i) => {
                let u = {
                  categoryKeys: sp.categories
                    .filter((s) => {
                      return s.isActive;
                    })
                    .map((s) => s._id),
                  sizeKeys: sp.menuSizes
                    ? sp.menuSizes
                        .filter((s) => {
                          return s.isActive;
                        })
                        .map((s) => s._id)
                    : [],
                  modifierKeys: sp.subModifiers
                    ? sp.subModifiers
                        .filter((s) => {
                          return s.isActive;
                        })
                        .map((s) => s._id)
                    : [],
                  menuItems: sp.menuItems
                    .filter((s) => {
                      return !s.isActive;
                    })
                    .map((s) => s._id),
                  id: i + 1,
                  isSlotOccupied: false,
                };
                x.slots.push(u);
                return _m;
              });
              return sp;
            });
          x.slotLength = x.slots.length;
          specialFrames.push(x);
        }
      }
    }
    return specialFrames;
  };

  isSpecialAvaiableAllDay = (special, delDate, timeZone) => {
    if (special.isAvailableFullDay) return true;
    else {
      let todayDate = moment(
        moment().tz(timeZone).format('YYYY-MM-DD HH:mm'),
        'YYYY-MM-DD HH:mm'
      );
      if (delDate) {
        todayDate = moment(delDate, 'YYYY-MM-DD HH:mm');
      }
      const { startTime, endTime } = special;
      const startObj = moment(
        moment()
          .tz(timeZone)
          .startOf('day')
          .add(startTime, 'seconds')
          .format('YYYY-MM-DD HH:mm'),
        'YYYY-MM-DD HH:mm'
      );

      const endObj = moment(
        moment()
          .tz(timeZone)
          .startOf('day')
          .add(endTime, 'seconds')
          .format('YYYY-MM-DD HH:mm'),
        'YYYY-MM-DD HH:mm'
      );

      if (
        startObj.isSameOrBefore(todayDate) &&
        endObj.isSameOrAfter(todayDate)
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  isSpecialAvaiableOnPublicHoliday = (special, delDate, timeZone) => {
    const { home, publicHolidays } = this.props;

    let todayDate = moment(
      moment().tz(timeZone).format('YYYY-MM-DD HH:mm'),
      'YYYY-MM-DD HH:mm'
    );
    if (delDate) {
      todayDate = moment(delDate, 'YYYY-MM-DD HH:mm');
    }
    if (
      home?.orderSetup?.isOptedInForHolidaySurcharge &&
      home?.orderSetup?.publicHolidaySurcharge &&
      publicHolidays?.length > 0
    ) {
      let dates = publicHolidays.filter((m) => {
        return m === moment(todayDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');
      });
      if (dates.length > 0 && !special.isAvailablePublicHoliday) return false;
      else return true;
    } else return true;
  };

  showSpecialItem = (arrObj) => {
    let obj = JSON.parse(JSON.stringify(arrObj));
    if (obj.selectedIngredients) {
      obj.selectedIngredients = obj.selectedIngredients.map((i) => {
        i.inOrder = true;
        return i;
      });
    }
    if (this.props.spMenuSizes && this.props.spSubModifiers) {
      let activeSizes = this.props.spMenuSizes.filter((o) => {
        return o.isActive === true;
      });
      let activeSubModifiers = this.props.spSubModifiers.filter((o) => {
        return o.isActive === true;
      });
      if (obj.selectedSizes && obj.selectedSizes.length === 1) {
        obj.selectedSizes = obj.selectedSizes.map((item) => {
          if (!item.quantity) {
            item.quantity = 1;
            item.isDisplayForSpecialOrHalfHalf = true;
          }
          item.isSingleSize = true;
          return item;
        });
      } else {
        let selectedItems = [];
        obj.selectedSizes = obj.selectedSizes.map((item) => {
          let matchingActiveSize = activeSizes.filter((s) => {
            return s._id === item._id && s.isActive;
          });
          let matchingActiveSubModifier = activeSubModifiers.filter((s) => {
            return s._id === item._id && s.isActive;
          });
          if (
            matchingActiveSize.length > 0 ||
            matchingActiveSubModifier.length > 0
          ) {
            item.isDisplayForSpecialOrHalfHalf = true;
            selectedItems.push(item);
          }
          return item;
        });
        if (selectedItems.length === 1) {
          obj.selectedSizes.map((item) => {
            if (item._id === selectedItems[0]._id) {
              item.quantity = 1;
              item.isDisplayForSpecialOrHalfHalf = true;
            } else item.isDisplayForSpecialOrHalfHalf = false;
            return item;
          });
          obj.isDisplayForSpecialOrHalfHalf = false;
        } else {
          obj.isDisplayForSpecialOrHalfHalf = true;
        }
      }
      obj.isSpecialItem = true;
      obj.isHalf = false;
      this.setState((prevState) => {
        return {
          arrKey: arrObj.name,
          rightSideViewVisibilityIndex: 2,
          toggleSpeacialItem:
            prevState.arrKey === arrObj.name
              ? this.state.toggleSpeacialItem
              : !this.state.toggleSpeacialItem,
          orderItem: obj,
          itemInProgress: obj,
        };
      });
    }
  };

  showHalfItem = (arrObj) => {
    let obj = JSON.parse(JSON.stringify(arrObj));
    if (obj.selectedIngredients) {
      obj.selectedIngredients.map((i) => {
        i.inOrder = true;
        return i;
      });
    }
    if (obj.selectedSizes && obj.selectedSizes.length === 1) {
      obj.selectedSizes = obj.selectedSizes.map((item) => {
        if (!item.quantity) item.quantity = 0.5;
        item.isSingleSize = true;
        if (item.variants) {
          item.variants.map((v) => {
            let matchingVariants = this.state.itemVariants.filter((ss) => {
              return ss._id === v._id;
            });
            if (matchingVariants.length > 0) {
              v.quantity = 0.5;
              v.isSelected = true;
            }
            return v;
          });
        }
        item.isDisplayForSpecialOrHalfHalf = true;
        return item;
      });
    } else {
      obj.selectedSizes = obj.selectedSizes.map((item) => {
        if (
          !item.quantity &&
          this.state.hhActiveMenuSizes &&
          this.state.hhActiveMenuSizes.map((m) => m._id).includes(item._id)
        ) {
          item.quantity = 0.5;
          if (item.variants) {
            item.variants.map((v) => {
              let matchingVariants = this.state.itemVariants.filter((ss) => {
                return ss._id === v._id;
              });
              if (matchingVariants.length > 0) {
                v.quantity = 0.5;
                v.isSelected = true;
              }
              return v;
            });
          }
          item.isDisplayForSpecialOrHalfHalf = true;
        } else {
          item.isDisplayForSpecialOrHalfHalf = false;
        }
        return item;
      });
    }

    obj.isHalf = true;
    obj.itemVariants = this.state.itemVariants;

    this.setState((prevState) => {
      return {
        arrKey: arrObj.name,
        rightSideViewVisibilityIndex: 5,
        toggleSpeacialItem:
          prevState.arrKey === arrObj.name
            ? this.state.toggleSpeacialItem
            : !this.state.toggleSpeacialItem,
        orderItem: obj,
        itemInProgress: obj,
      };
    });
  };

  showHalfViewHandler = (arrObj) => {
    const isMobile =
      window.innerWidth < 992 ||
      (window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250);
    this.setState(
      {
        rightSideViewVisibilityIndex: 4,
      },
      () => {
        this.setState((prevState) => ({
          halfAnimation:
            prevState.arrKey === arrObj.name
              ? this.state.halfAnimation
              : !this.state.halfAnimation,
          arrKey: arrObj.name,
          selectedHalfItems: [],
          halfItem: arrObj,
          whichHalf: isMobile ? null : 1,
        }));
      }
    );
  };

  halfFilter = (whichHalf, itemVariants, hhActiveMenuSizes) => {
    this.setState({
      whichHalf,
      itemVariants,
      hhActiveMenuSizes,
    });
    if (
      window.innerWidth < 992 ||
      (window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250)
    ) {
      this.setState({ rightSideViewVisibilityIndex: 0 });
    }
  };

  clearOrChangeSize = (hhActiveMenuSizes, itemVariants) => {
    let newHalfObject = [];
    if (this.state.selectedHalfItems && this.props.home.menuItems) {
      let selectedHalfItems = JSON.parse(
        JSON.stringify(this.state.selectedHalfItems)
      );
      if (selectedHalfItems.length >= 1 && selectedHalfItems[0]._id) {
        let firstHalf = selectedHalfItems[0];
        let matchingItems = this.props.home.menuItems.filter((m) => {
          return m._id === firstHalf._id;
        });
        if (matchingItems.length > 0) {
          let menuItem = JSON.parse(JSON.stringify(matchingItems[0]));
          let matchingSizes = menuItem.selectedSizes.filter((f) => {
            return hhActiveMenuSizes.map((m) => m._id).includes(f._id);
          });
          if (matchingSizes.length > 0) {
            let matchingSize = matchingSizes[0];
            if (itemVariants.length <= 0) {
              matchingSize.quantity = 0.5;
              firstHalf.selectedSizes = [{ ...matchingSize, variants: [] }];
              if (firstHalf.itemType === 1) {
                firstHalf.selectedModifiers.map((sm) => {
                  if (firstHalf.baseModifierId === sm._id && sm.subModifiers) {
                    sm.subModifiers = [{ ...matchingSize, variants: [] }];
                  }
                  return sm;
                });
              }
              newHalfObject.push(firstHalf);
            } else {
              if (matchingSize.variants) {
                let cnt = 0;
                matchingSize.variants.map((sv) => {
                  let matchingVar = itemVariants.filter((f) => {
                    return f._id === sv._id;
                  });
                  if (matchingVar.length > 0) cnt = cnt + 1;
                  return sv;
                });
                if (cnt === itemVariants.length) {
                  matchingSize.quantity = 0.5;
                  matchingSize.variants.map((sv) => {
                    let matchingVar = itemVariants.filter((f) => {
                      return f._id === sv._id;
                    });
                    if (matchingVar.length > 0) sv.quantity = 0.5;
                    return sv;
                  });
                  firstHalf.selectedSizes = [matchingSize];
                  //Complex type
                  if (firstHalf.itemType === 1) {
                    firstHalf.selectedModifiers.map((sm) => {
                      if (
                        firstHalf.baseModifierId === sm._id &&
                        sm.subModifiers
                      ) {
                        sm.subModifiers = [matchingSize];
                      }
                      return sm;
                    });
                  }
                  newHalfObject.push(firstHalf);
                }
              }
            }
          }
        }
      }
      if (selectedHalfItems.length >= 2 && selectedHalfItems[1]._id) {
        let secondHalf = selectedHalfItems[1];
        let matchingItems = this.props.home.menuItems.filter((m) => {
          return m._id === secondHalf._id;
        });
        if (matchingItems.length > 0) {
          let menuItem = JSON.parse(JSON.stringify(matchingItems[0]));
          let matchingSizes = menuItem.selectedSizes.filter((f) => {
            return hhActiveMenuSizes.map((m) => m._id).includes(f._id);
          });
          if (matchingSizes.length > 0) {
            let matchingSize = matchingSizes[0];
            matchingSize.quantity = 0.5;
            if (itemVariants.length <= 0) {
              matchingSize.quantity = 0.5;
              secondHalf.selectedSizes = [{ ...matchingSize, variants: [] }];
              //Complex type
              if (secondHalf.itemType === 1) {
                secondHalf.selectedModifiers.map((sm) => {
                  if (secondHalf.baseModifierId === sm._id && sm.subModifiers) {
                    sm.subModifiers = [{ ...matchingSize, variants: [] }];
                  }
                  return sm;
                });
              }
              newHalfObject.push(secondHalf);
            } else {
              if (matchingSize.variants) {
                let cnt = 0;
                matchingSize.variants.map((sv) => {
                  let matchingVar = itemVariants.filter((f) => {
                    return f._id === sv._id;
                  });
                  if (matchingVar.length > 0) cnt = cnt + 1;
                  return sv;
                });
                if (cnt === itemVariants.length) {
                  matchingSize.quantity = 0.5;
                  matchingSize.variants.map((sv) => {
                    let matchingVar = itemVariants.filter((f) => {
                      return f._id === sv._id;
                    });
                    if (matchingVar.length > 0) sv.quantity = 0.5;
                    return sv;
                  });
                  secondHalf.selectedSizes = [matchingSize];
                  //Complex type
                  if (secondHalf.itemType === 1) {
                    secondHalf.selectedModifiers.map((sm) => {
                      if (
                        secondHalf.baseModifierId === sm._id &&
                        sm.subModifiers
                      ) {
                        sm.subModifiers = [matchingSize];
                      }
                      return sm;
                    });
                  }
                  newHalfObject.push(secondHalf);
                }
              }
            }
          }
        }
      }
      this.setState({ selectedHalfItems: newHalfObject, itemVariants });
    } else {
      this.setState({ itemVariants });
    }
  };

  showMenuItemHandler = (arrObj) => {
    let obj = arrObj ? JSON.parse(JSON.stringify(arrObj)) : {};
    if (obj.selectedIngredients) {
      obj.selectedIngredients.map((i) => {
        i.inOrder = true;
        return i;
      });
    }
    if (obj.selectedSizes && obj.selectedSizes.length === 1) {
      let isSoldOut = false;
      const { soldOutMenuItems } = this.props;
      if (soldOutMenuItems) {
        isSoldOut =
          obj.itemType === 1
            ? obj.selectedModifiers.some((j) =>
                j.subModifiers.every((sm) => {
                  const basesSoldOut =
                    soldOutMenuItems.findIndex(
                      (k) =>
                        k.smId === sm._id &&
                        k.menuItemId === obj._id &&
                        k.variantId === null
                    ) !== -1;

                  const variants = sm.variants || [];

                  const variantsSoldOut =
                    variants.lenth === 0
                      ? false
                      : (sm.variants || []).every(
                          (v) =>
                            soldOutMenuItems.findIndex(
                              (l) =>
                                l.smId === sm._id &&
                                l.menuItemId === obj._id &&
                                l.variantId === v._id
                            ) !== -1
                        );

                  return basesSoldOut && variantsSoldOut;
                })
              )
            : obj.selectedSizes.every((s) => {
                const basesSoldOut =
                  soldOutMenuItems.findIndex(
                    (k) =>
                      k.smId === s._id &&
                      k.menuItemId === obj._id &&
                      k.variantId === null
                  ) !== -1;

                const variants = s.variants || [];

                const variantsSoldOut =
                  variants.lenth === 0
                    ? false
                    : (s.variants || []).every(
                        (v) =>
                          soldOutMenuItems.findIndex(
                            (k) =>
                              k.smId === s._id &&
                              k.menuItemId === obj._id &&
                              k.variantId === v._id
                          ) !== -1
                      );

                return basesSoldOut && variantsSoldOut;
              });
      }
      obj.isSoldOut = isSoldOut;
      obj.selectedSizes = obj.selectedSizes.map((item) => {
        if (isSoldOut) return item;
        if (!item.quantity) item.quantity = 1;
        item.isSingleSize = true;
        return item;
      });
    }
    obj.isHalf = false;
    if (typeof arrObj !== 'undefined') {
      this.setState((prevState) => ({
        arrKey: arrObj._id,
        rightSideViewVisibilityIndex: 1,
        toggleAnimation:
          prevState.arrKey === arrObj._id
            ? this.state.toggleAnimation
            : !this.state.toggleAnimation,
        orderItem: obj,
        itemInProgress: obj,
      }));
    }
  };

  hideOrder = () => {
    const { filterView } = this.props;
    const { halfItem, specialItem } = this.state;

    const isSpecialOpen = Object.keys(specialItem).length > 0;
    const isHalfOpen = Object.keys(halfItem).length > 0;

    if (isSpecialOpen && isHalfOpen) {
      this.setState({
        halfItem: {},
        rightSideViewVisibilityIndex: isSpecialOpen ? 3 : 0,
        itemInProgress: null,
      });
    } else if (isSpecialOpen) {
      this.setState({
        specialItem: {},
        rightSideViewVisibilityIndex: 0,
        itemInProgress: null,
      });

      filterView({
        isSpecialFilterApplied: false,
        spMenuItems: [],
        spMenuSizes: [],
        spSubModifiers: [],
        spMenuCategories: [],
        boxIndex: -1,
        itemExist: -1,
      });
    } else if (isHalfOpen) {
      this.setState({
        halfItem: {},
        rightSideViewVisibilityIndex: 0,
        itemInProgress: null,
      });
    } else {
      this.setState({ rightSideViewVisibilityIndex: 0, itemInProgress: null });
    }
  };

  hideSpecialItem = () => {
    this.setState({ rightSideViewVisibilityIndex: 3, itemInProgress: null });
  };

  mobileGoback = () => {
    this.setState({ rightSideViewVisibilityIndex: 4 });
  };

  hideHalfItem = () => {
    this.setState({ rightSideViewVisibilityIndex: 4, itemInProgress: null });
  };

  filterView = (
    spMenuItems,
    spMenuSizes,
    spSubModifiers,
    spMenuCategories,
    boxIndex,
    itemExist
  ) => {
    this.props.filterView({
      isSpecialFilterApplied: true,
      boxIndex,
      itemExist,
      spMenuItems,
      spMenuSizes,
      spSubModifiers,
      spMenuCategories,
    });
    if (
      window.innerWidth < 992 ||
      (window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250)
    ) {
      this.setState({ rightSideViewVisibilityIndex: 0 });
    }
  };

  signOut = () => {
    _auth.signOut().then(() => {
      this.setState({ currentUser: {}, userDetails: {} }, () => {
        this.props.takeSignOutAction();
      });
    });
  };

  goHome = () => {
    const { setState, currentOrder } = this.props;
    const { orderStatus, id, orderType } = currentOrder;
    if (
      orderStatus === '1' ||
      orderStatus === '4' ||
      orderStatus === '11' ||
      this.qrRedirect === 'true' ||
      this.qrTracking === 'close'
    ) {
      let ctOrder = {
        paymentType: '0',
        orderStatus: '0',
        orderFrom: '1',
        orderType: orderType === '3' ? '3' : '1',
        specials: [],
        menuItems: [],
        stage: 0,
        totalCost: 0,
        payableAmount: 0,
        date: '',
        deliveryCode: '',
        deliveryCost: '0',
        deliveryDate: '',
        id,
        index: 68,
        shiftId: '',
        voucherId: '',
        userId: '',
        driverId: '',
        suburbId: '',
        txnId: '',
        transactionReference: '',
        cardNumber: '',
        cardType: '',
      };

      let newOrder = this.getOrderCalculations(ctOrder);

      this.setState({ driver: {} }, () => {
        if (this.props.mobileCart) this.props.toggleMobileCart();
        newOrder.floorLayoutId = currentOrder.floorLayoutId;
        newOrder.tableNumber = currentOrder.tableNumber;
        if (
          orderType === '3' ||
          this.qrRedirect === 'true' ||
          this.qrTracking === 'close'
        ) {
          this.props.history.replace({
            query: null,
          });
        }
      });
      setState({ currentOrder: newOrder });
    }
  };

  render() {
    const { isSpecialFilterApplied, currentOrder } = this.props;
    const { halfItem, showSelectTable, showConfirmTable, floors } = this.state;
    const halfView = Object.keys(halfItem).length > 0;

    return (
      <React.Fragment>
        <Layout
          showHalfItem={halfView}
          halfItem={this.state.halfItem}
          signOut={this.signOut}
          goHome={this.goHome}
          hOrder={this.mobileGoback}
          review={this.state.review}
          reservation={this.state.reservation}
          closeLoyalty={this.closeLoyalty}
          loyalty={this.state.loyalty}
          updateCurrentUser={this.updateCurrentUser}
          updateOrderStage={this.updateOrderStage}
          openDelivery={this.state.openDelivery}
          addReservationhandler={this.addReservationhandler}
        >
          <div
            className={`container-fluid shadowIt ${
              isSpecialFilterApplied ? 'spViewActive' : ''
            }`}
          >
            <div className='row' style={{ overflow: 'auto' }}>
              <div
                className={
                  !!currentOrder &&
                  currentOrder.stage &&
                  currentOrder.stage >= '5'
                    ? 'col-xs-12 customWidth noPad'
                    : currentOrder.stage >= 3
                    ? 'col-md-8 customWidth mapStage'
                    : 'col-md-8 customWidth'
                }
              >
                <div className='map-items' style={{ height: '100%' }}>
                  {currentOrder &&
                  currentOrder.stage &&
                  currentOrder.stage >= 3 &&
                  currentOrder.isAllowToConfirm ? (
                    <ReviewOrder
                      updateOrderDeliveryAddress={
                        this.updateOrderDeliveryAddress
                      }
                      updateDeliveryPickupTime={this.updateDeliveryPickupTime}
                      saveUnit={this.saveUnit}
                    />
                  ) : (
                    <MenuItems
                      halfView={halfView}
                      halfItem={this.state.halfItem}
                      hhActiveMenuSizes={this.state.hhActiveMenuSizes}
                      showSpecialsHandler={this.showSpecialsHandler}
                      showHalfViewHandler={this.showHalfViewHandler}
                      showMenuItemHandler={this.showMenuItemHandler}
                      showSpecialItem={this.showSpecialItem}
                      showHalfItem={this.showHalfItem}
                      history={this.props.history}
                      itemVariants={this.state.itemVariants}
                      selectedHalfItems={this.state.selectedHalfItems}
                      initiateDesktopLoyaltyFlow={
                        this.state.initiateDesktopLoyaltyFlow
                      }
                    />
                  )}
                </div>
              </div>
              {currentOrder && (
                <Order
                  hideSpecialItem={this.hideSpecialItem}
                  filterView={this.filterView}
                  toggleSpecials={this.state.toggleSpecials}
                  specialItem={this.state.specialItem}
                  showSpecialItem={this.showSpecialItem}
                  hideOrder={this.hideOrder}
                  halfAnimation={this.state.halfAnimation}
                  halfItem={this.state.halfItem}
                  toggleSpeacialItem={this.state.toggleSpeacialItem}
                  orderItem={this.state.orderItem}
                  itemInProgress={this.state.itemInProgress}
                  toggleAnimation={this.state.toggleAnimation}
                  halfFilter={this.halfFilter}
                  updateOrderType={this.updateOrderType}
                  addToOrder={this.addToOrder}
                  incrementItemQuantity={this.incrementItemQuantity}
                  decrementItemQuantity={this.decrementItemQuantity}
                  incrementExtraQuantity={this.incrementExtraQuantity}
                  decrementExtraQuantity={this.decrementExtraQuantity}
                  updateOrderDeliveryAddress={this.updateOrderDeliveryAddress}
                  updateDeliveryPickupTime={this.updateDeliveryPickupTime}
                  updateOrderStage={this.updateOrderStage}
                  updateOrderStageBack={this.updateOrderStageBack}
                  updateCurrentUser={this.updateCurrentUser}
                  updateVoucher={this.updateVoucher}
                  updatePaymenyType={this.updatePaymenyType}
                  updatePaymentTypeForCash={this.updatePaymentTypeForCash}
                  updatePaymentTypeForWallet={this.updatePaymentTypeForWallet}
                  updatePaymentTypeForCard={this.updatePaymentTypeForCard}
                  updatePaymentTypeForNewCard={this.updatePaymentTypeForNewCard}
                  addToSpecial={this.addToSpecial}
                  rightSideViewVisibilityIndex={
                    this.state.rightSideViewVisibilityIndex
                  }
                  selectedSpecials={this.state.selectedSpecials}
                  addSpecialToOrder={this.addSpecialToOrder}
                  selectedHalfItems={this.state.selectedHalfItems}
                  addToHalfHalf={this.addToHalfHalf}
                  hideHalfItem={this.hideHalfItem}
                  addHalfHalfToOrder={this.addHalfHalfToOrder}
                  clearItemsNotAvailableForVariants={
                    this.clearItemsNotAvailableForVariants
                  }
                  whichHalf={this.state.whichHalf}
                  menuItems={this.props.home.menuItems}
                  clearOrChangeSize={this.clearOrChangeSize}
                  history={this.props.history}
                  saveUnit={this.saveUnit}
                  itemExist={this.state.itemExist}
                  initiateDesktopLoyaltyFlow={
                    this.state.initiateDesktopLoyaltyFlow
                  }
                  loyalty={this.state.loyalty}
                  addReservationhandler={this.addReservationhandler}
                  reservation={this.state.reservation}
                  userDetails={this.props.home.userDetails}
                  currentUser={this.props.home.currentUser}
                  removeSoldOutItems={this.removeSoldOutItems}
                  removeOutOfScheduleItems={this.removeOutOfScheduleItems}
                  openDelivery={this.state.openDelivery}
                  getDiscountedAmount={this.getDiscountedAmount}
                  inLayoutFlow={this.state.inLayoutFlow}
                  dineInObjects={this.state.dineInObjects}
                  floors={this.state.floors}
                  addTableToOrder={this.addTableToOrder}
                  getItemPrice={this.getItemPrice}
                />
              )}
              {this.props.currentOrder?.orderType === '3' &&
                !this.props.currentOrder?.tableNumber &&
                this.props.mobileCart &&
                this.props.currentOrder?.stage < 4 && (
                  <>
                    {showConfirmTable && (
                      <ConfirmTable
                        confirmTable={this.confirmTable}
                        hideModal={() => {
                          this.setState({ showConfirmTable: false });
                        }}
                      />
                    )}
                    {showSelectTable && (
                      <SelectTable
                        floors={floors}
                        hideModal={() => {
                          this.setState({
                            showSelectTable: false,
                            showConfirmTable: true,
                          });
                        }}
                        addTableToOrder={this.addTableToOrder}
                      />
                    )}
                  </>
                )}
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {
    homeReducer: {
      soldOutMenuItems,
      currentOrder,
      bookingOpen,
      specialFilter: {
        isSpecialFilterApplied,
        spMenuItems,
        spMenuSizes,
        spSubModifiers,
        spMenuCategories,
        boxIndex,
      },
      menuItemSchedules,
      ui: { mobileCart },
    },
    layoutReducer: {
      storeConfig,
      halfHalfSetup,
      offers,
      autoVouchers,
      publicHolidays,
    },
  } = state;

  return {
    isSpecialFilterApplied,
    spMenuItems,
    spMenuSizes,
    spSubModifiers,
    spMenuCategories,
    soldOutMenuItems,
    boxIndex,
    mobileCart,
    halfHalfSetup,
    currentOrder,
    bookingOpen,
    menuItemSchedules,
    offers,
    autoVouchers,
    publicHolidays,
    home: state.homeReducer,
    order: state.orderReducer,
    reviewOrder: state.reviewOrderReducer,
    storeConfig,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setState: (st) => dispatch(setState(st)),
    updateCurrentOrderObjHandler: (id, obj) =>
      dispatch(updateCurrentOrderObj(id, obj)),
    takeSignOutAction: () => dispatch(takeSignOutAction()),
    filterView: (filter) => dispatch(filterView(filter)),
    initAction: (storeId, restaurantId) =>
      dispatch(init(storeId, restaurantId)),
    toggleMobileCart: () => dispatch(toggleMobileCart()),
    setLayoutFlow: (value) => dispatch(setLayoutFlow(value)),
    getCurrentUseDetailsHandler: (
      uid,
      newUser,
      storeId,
      restaurantId,
      isLogin
    ) =>
      dispatch(
        getCurrentUseDetails(uid, newUser, storeId, restaurantId, isLogin)
      ),
    addReservationhandler: (reservation, userDetails) =>
      dispatch(addReservation(reservation, userDetails)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
